/**
 * English translations — default language
 * Complete coverage of all public-facing UI text
 */
const en: Record<string, string> = {
  // ── Navigation ─────────────────────────────────────
  'nav.explore': 'Explore',
  'nav.artWorld': 'Art World',
  'nav.pricing': 'Pricing',
  'nav.contact': 'Contact',
  'nav.myStudio': 'My ArtRouting',
  'nav.admin': 'Admin',
  'nav.login': 'Login',
  'nav.register': 'Register',
  'nav.logout': 'Logout',
  'nav.goBack': 'Back',
  'nav.map': 'Map',
  'nav.discover': 'Discover',
  'nav.routes': 'Routes',
  'nav.artists': 'Artists & Curators',
  'nav.artradar': 'ArtRadar',
  'nav.events': 'Events',
  'nav.myProfile': 'My Profile',
  'nav.myPins': 'My Pins',
  'nav.myArtworks': 'My Artworks',
  'nav.myProvenance': 'My Provenance',
  'nav.myRoutes': 'My Routes',
  'nav.myEvents': 'My Events',
  'nav.myArtists': 'My Artists',
  'nav.myCurators': 'My Curators',
  'nav.myArticles': 'My Articles',
  'myEvents.title': 'My Events',
  'nav.saved': 'Saved',
  'nav.import': 'Import Profile',
  'nav.subscription': 'My Subscription',
  'nav.docs': 'Docs',
  'nav.viewingAs': 'Viewing as',
  'nav.returnToAdmin': 'Return to Admin',

  // ── Footer ─────────────────────────────────────────
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Use',
  'footer.cookies': 'Cookie Policy',
  'footer.tagline': 'Cultural discovery for everyone.',

  // ── Hero / Landing ─────────────────────────────────
  'hero.headline': 'Discover art where it lives.',
  'hero.subtitle': 'Explore artists, galleries, studios, and cultural places through a living map of discovery.',
  'hero.cta1': 'Open the Map',
  'hero.cta2': 'ArtRadar',
  'hero.scroll': 'Scroll',
  'card1.title': 'For artists',
  'card1.desc': 'Be found where you create. Profiles, places, and visibility anchored in real geography.',
  'card1.cta': 'Claim your place',
  'card2.title': 'For explorers',
  'card2.desc': 'Find art around you. Follow routes, discover spaces, and experience culture on the ground.',
  'card2.cta': 'Follow your curiosity',
  'card3.title': 'ArtRadar',
  'card3.desc': 'Stories, highlights, and curated cultural signals that bring the map to life.',
  'card3.cta': 'Read the signal',
  'card4.title': 'For galleries',
  'card4.desc': 'Showcase your exhibitions, connect with collectors, and put your gallery on the cultural map.',
  'card4.cta': 'List your gallery',
  'explain.title': 'How ArtRouting Works',
  'explain.desc': 'ArtRouting connects artists, studios, galleries and cultural locations through an interactive map. Discover art geographically \u2014 follow routes through open studios, find exhibitions nearby, and explore culture on the ground.',
  'explain.pins': 'Cultural Pins',
  'explain.pinsDesc': 'Artists, studios, galleries and cultural locations appear as pins on the map.',
  'explain.profiles': 'Rich Profiles',
  'explain.profilesDesc': 'Each pin opens a profile with images, exhibitions, opening hours and contact details.',
  'explain.routes': 'Cultural Routes',
  'explain.routesDesc': 'Places connect into routes that let visitors explore regions through art and culture.',
  'explain.cta': 'Join ArtRouting',
  'explain.ctaAuth': 'Add Your Studio to the Map',

  // ── Pricing ────────────────────────────────────────
  'pricing.title': 'Choose Your Plan',
  'pricing.subtitle': 'Four roles, three choices in each — Free, Active and Pro. Hold several roles and pay only once, for the highest plan you select.',
  'pricing.artists': 'Artists',
  'pricing.galleries': 'Art Venues',
  'pricing.earlyAccess': 'Early Access pricing \u2014 available during initial launch phase',
  'pricing.currentPlan': 'Current Plan',
  'pricing.yourPlan': 'YOUR PLAN',
  'pricing.yourCurrentPlan': 'Your Current Plan',
  'pricing.signUpFree': 'Sign Up Free',
  'pricing.signInToSubscribe': 'Sign In to Subscribe',
  'pricing.downgradeToFree': 'Downgrade to Free',
  'pricing.subscribe': 'Subscribe',
  'pricing.upgrade': 'Upgrade',
  'pricing.switchPlan': 'Switch Plan',
  'pricing.processing': 'Processing...',
  'pricing.activating': 'Activating your subscription...',
  'pricing.loading': 'Loading pricing...',
  'pricing.loadFailed': 'Failed to load pricing information.',
  'pricing.featureAccess': 'Feature Access by Tier',
  'pricing.menuFeature': 'Menu / Feature',
  'pricing.paypalError': 'PayPal encountered an error. Please try again.',
  'pricing.paypalLoading': 'PayPal subscriptions loading...',
  'pricing.pioneer.title': 'Pioneer \u2014 Early Access',
  'pricing.pioneer.desc': 'Full access to all features \u2014 assigned by invitation. Thank you for being a Pioneer!',
  'pricing.pioneer.free': 'Free',
  'pricing.pioneer.inviteOnly': 'Invite only',
  'pricing.pioneer.fullProfile': 'Full Profile',
  'pricing.pioneer.artworkGallery': 'Artwork Gallery',
  'pricing.pioneer.artradar': 'ArtRadar',
  'pricing.pioneer.routes': 'Routes',
  'pricing.pioneer.priorityVisibility': 'Priority Visibility',
  'pricing.pioneer.exhibitions': 'Exhibitions',
  'pricing.pioneer.collectorSignals': 'Collector Signals',
  // Tier cards — the bold line is what you see first, the explanation opens on click
  'pricing.explorers': 'Explorers',
  'pricing.whatsIncluded': 'What you get',
  'pricing.tapToExpand': 'Tap any feature to see what it means',
  'pricing.showExplanation': 'Show what this means',
  'pricing.hideExplanation': 'Hide explanation',
  'pricing.howToRead': 'How to read these plans',
  'pricing.sharedTiers.title': 'Shared Tiers — several roles, one payment',
  'pricing.sharedTiers.body': 'Choose several roles — Artist, Art Venue, Explorer and Heritage. Pay once for the highest-priced selected plan. Role-specific features and limits apply to the selected tier of each role.',
  'pricing.coveredByYourPlan': 'Covered by your plan',
  'pricing.learnMoreRole': 'Learn more about this role',
  'pricing.learnLessRole': 'Show less',
  'pricing.comingSoon': 'Coming soon',
  // Profile galleries
  'gallery.close': 'Close',
  'gallery.credit': 'Credit',
  'gallery.moreInfo': 'More information',
  'gallery.rotating': 'Profile gallery',
  'gallery.manage': 'Manage gallery',
  'gallery.enlarge': 'Open larger view',
  'gallery.announcement': 'Announcement',
  'gallery.previous': 'Previous image',
  'gallery.next': 'Next image',
  'gallery.goTo': 'Show image {n} of {total}',
  'gallery.play': 'Resume slideshow',
  'gallery.pause': 'Pause slideshow',
  'gallery.additional': 'Gallery',
  'gallery.when': 'When',
  'gallery.where': 'Where',
  'gallery.why': 'Why',
  'gallery.provenance': 'QR provenance',
  'gallery.availability.available': 'Available',
  'gallery.availability.reserved': 'Reserved',
  'gallery.availability.sold': 'Sold',
  'gallery.availability.not_available': 'Not available',
  'gallery.availability.on_loan': 'On loan',
  'gallery.videos': 'Videos',
  'gallery.video': 'Video',
  'gallery.playVideo': 'Play video',
  'galleryEditor.title': 'Manage gallery',
  'galleryEditor.back': 'Back to the profile',
  'galleryEditor.denied': 'Only the owner, an authorised Delegated Author or an admin can manage this gallery.',
  'galleryEditor.usage.rotating': '{used} of {max} rotating images used',
  'galleryEditor.usage.additional': '{used} of {max} additional images used',
  'galleryEditor.usage.additionalNone': 'Additional images begin with Active',
  'galleryEditor.usage.videos': '{used} of {max} video links used',
  'galleryEditor.window.free': 'Free: gallery changes once per calendar month.',
  'galleryEditor.window.active': 'Active: gallery changes once per calendar week.',
  'galleryEditor.window.pro': 'Pro: change your gallery at any time.',
  'galleryEditor.window.session': 'Your editing session is open until {date} — finish arranging until then.',
  'galleryEditor.window.open': 'Your update window is open. Your first change starts a 24-hour editing session.',
  'galleryEditor.window.closed': 'This period’s update is used. The next window opens {date}.',
  'galleryEditor.window.alwaysAllowed': 'Always possible: removing an item, ending an announcement early, and marking an artwork sold or no longer available.',
  'galleryEditor.state.published': 'Public',
  'galleryEditor.state.live': 'Live',
  'galleryEditor.state.scheduled': 'Scheduled',
  'galleryEditor.state.expired': 'Expired',
  'galleryEditor.state.hidden_by_tier': 'Hidden by tier',
  'galleryEditor.kind.image': 'Image',
  'galleryEditor.kind.announcement': 'Announcement',
  'galleryEditor.kind.artwork': 'Artwork PIN',
  'galleryEditor.now': 'Now',
  'galleryEditor.alt': 'Alternative text (describes the image)',
  'galleryEditor.caption': 'Caption',
  'galleryEditor.credit': 'Image credit',
  'galleryEditor.when': 'When (date or year)',
  'galleryEditor.where': 'Where (place or exhibition)',
  'galleryEditor.save': 'Save',
  'galleryEditor.saved': 'Saved.',
  'galleryEditor.up': 'Move up',
  'galleryEditor.down': 'Move down',
  'galleryEditor.toAdditional': 'Move to gallery',
  'galleryEditor.toRotating': 'Move to rotating',
  'galleryEditor.edit': 'Edit',
  'galleryEditor.endNow': 'End now',
  'galleryEditor.ended': 'Announcement ended.',
  'galleryEditor.availability': 'Artwork status',
  'galleryEditor.statusSaved': 'Status updated everywhere this artwork appears.',
  'galleryEditor.confirmRemove': 'Remove this from the gallery? The connected artwork or record is not affected.',
  'galleryEditor.removed': 'Removed from the gallery.',
  'galleryEditor.remove': 'Remove',
  'galleryEditor.addImage': 'Add an image or announcement',
  'galleryEditor.section': 'Where it appears',
  'galleryEditor.sectionRotating': 'Rotating gallery (top)',
  'galleryEditor.sectionAdditional': 'Gallery (below)',
  'galleryEditor.kindLabel': 'Type',
  'galleryEditor.imageType': 'Image type',
  'galleryEditor.type.artwork': 'Artwork',
  'galleryEditor.type.detail': 'Detail',
  'galleryEditor.type.portrait': 'Portrait',
  'galleryEditor.type.studio': 'Studio / process',
  'galleryEditor.type.venue': 'Venue / space',
  'galleryEditor.type.exhibition': 'Exhibition / event',
  'galleryEditor.image': 'Image',
  'galleryEditor.imageHelp': 'JPEG, PNG or WebP. At least 1600 px on the longest side recommended. No video files.',
  'galleryEditor.externalUrl': 'Link (optional, https)',
  'galleryEditor.start': 'Show from',
  'galleryEditor.end': 'Show until',
  'galleryEditor.announcementHelp': 'Announcements appear only on this profile, disappear automatically at the end date and are not ArtRadar posts.',
  'galleryEditor.rights': 'I own this image or have permission to publish it; required permissions are in place and the credit is accurate.',
  'galleryEditor.add': 'Add',
  'galleryEditor.added': 'Added.',
  'galleryEditor.connectArtwork': 'Connect an Artwork PIN',
  'galleryEditor.connectArtworkHelp': 'Show current and history works from their Artwork PINs. A connection uses no image slot and never copies the artwork. When, where and — if the artwork has a permanent QR — why appear automatically.',
  'galleryEditor.searchArtworks': 'Search artworks by title',
  'galleryEditor.chooseArtwork': 'Choose an artwork…',
  'galleryEditor.whereArtworkHelp': 'Optional: where it was shown, if different from its PIN',
  'galleryEditor.connect': 'Connect',
  'galleryEditor.empty': 'Nothing here yet.',
  'galleryEditor.videoTitle': 'Title',
  'galleryEditor.addVideo': 'Add video link',
  'galleryEditor.err.generic': 'That did not work. Please try again.',
  'galleryEditor.err.update_window_closed': 'This period’s gallery update is already used. The next window opens {date}. Removing items, ending announcements and marking artworks sold stay possible.',
  'galleryEditor.err.alt_text_required': 'Alternative text is required.',
  'galleryEditor.err.rights_not_confirmed': 'Please confirm you have the right to publish this image.',
  'galleryEditor.err.invalid_image': 'Upload a JPEG, PNG or WebP image.',
  'galleryEditor.err.announcement_end_required': 'An announcement needs an end date.',
  'galleryEditor.err.announcement_end_before_start': 'The end must be after the start.',
  'galleryEditor.err.rotating_full': 'The rotating gallery already has 10 images.',
  'galleryEditor.err.additional_full': 'All additional image places of your tier are used.',
  'galleryEditor.err.additional_not_included': 'Additional images begin with Active.',
  'galleryEditor.err.videos_full': 'All YouTube places of your tier are used.',
  'galleryEditor.err.artwork_not_found': 'That artwork could not be found.',
  'galleryEditor.err.artwork_already_connected': 'This artwork is already in the gallery.',
  'galleryEditor.err.connected_not_found': 'The connected record could not be found.',
  'galleryEditor.err.invalid_external_url': 'Links must start with https://',
  'galleryEditor.err.announcement_rotating_only': 'Announcements belong in the rotating gallery.',
  // Homepage master 17 Sep 2026, Learn pages, Hero Image admin
  'hero.photoAlt': 'A visitor looks at two framed paintings on an easel in a blue-walled studio of carved frames.',
  'hero.credit.prefix': 'Artwork on easel by',
  'hero.credit.artistProfile': 'artist PIN',
  'hero.credit.shownAt': 'Shown at',
  'home.video.watch': 'Watch How ArtRouting Works',
  'home.video.close': 'Close video',
  'home.step.places.title': 'Places on the Map',
  'home.step.places.text': 'Artists, studios, art venues, exhibitions and artworks connect to real places where they can be discovered.',
  'home.step.places.cta': 'Put Yourself on the Map',
  'home.step.profiles.title': 'Profiles',
  'home.step.profiles.text': 'Open a PIN to discover the people, artworks, exhibitions and visitor information connected to that place.',
  'home.step.routes.title': 'Art Routes',
  'home.step.routes.text1': 'Let one discovery lead to another — from artist to studio, exhibition, gallery or another cultural place.',
  'home.step.routes.text2': 'Artists and art venues can also connect and collaborate to create routes together — coordinating visits, opening times and experiences across a region.',
  'home.step.routes.text3': 'Create your own route through the art of a region.',
  'home.step.journeys.title': 'Artwork Journeys',
  'home.step.journeys.text': 'Follow how an artwork moves from studio to exhibitions, galleries, collections and new locations while building its history.',
  'home.closing.title': 'ArtRouting connects the journey.',
  'home.closing.line1': 'People discover art through places.',
  'home.closing.line2': 'Artworks build histories through the places they travel.',
  'home.closing.line3': 'ArtRouting connects both.',
  'home.plan.title': 'Choose Your Plan',
  'home.plan.text': 'Start free and choose the level of participation that fits your needs.',
  'home.plan.button': 'Choose Your Plan',
  'learn.collaboration.title': 'Work Together',
  'learn.collaboration.p1': 'Many artists and art venues have help: an assistant, a gallery manager, a family member, a curator. ArtRouting lets you give a named, registered person permission to help manage your profile, artworks, exhibitions and information.',
  'learn.collaboration.p2': 'You choose exactly what they may do, action by action. They see the same list and accept or decline each part, and both of you accept the same rules. Nothing is active until you have both agreed.',
  'learn.collaboration.p3': 'You always remain in control: you can reduce or revoke access at any time, every change is recorded, and you are told when your Delegated Author makes meaningful changes.',
  'learn.collaboration.p4': 'Your account, password, billing and the right to revoke access are never shared. Accepting delegated access is possible on every tier; your tier decides how many people you may appoint.',
  'learn.collaboration.ctaAuth': 'Open Delegated Authorship',
  'learn.collaboration.ctaAnon': 'Create a free account',
  'learn.messaging.title': 'Connect',
  'learn.messaging.p1': 'ArtRouting Messages let you write directly to artists, art venues and other participants — to ask about a studio visit, an exhibition, an artwork or what else there is to discover nearby.',
  'learn.messaging.p2': 'Conversations stay private between the people in them. Approved images and PDFs can be attached, and you can switch messages off or block someone at any time.',
  'learn.messaging.p3': 'A conversation can become the next step in your art route.',
  'learn.messaging.ctaAuth': 'Open Messages',
  'learn.messaging.ctaAnon': 'Create a free account',
  'adminLanding.slogan1': 'Slogan line 1',
  'adminLanding.slogan2': 'Slogan line 2',
  'adminLanding.support': 'Supporting line (optional)',
  'adminLanding.heroImageNote': 'The photograph and its credit links are managed separately:',
  'adminLanding.card4': 'For Art Venues',
  'adminLanding.card5': 'Work Together',
  'adminLanding.card6': 'Connect',
  'adminLanding.card7': 'Heritage',
  'adminLanding.videoUrl': 'Explainer video — YouTube link (optional; the Watch button appears only when set)',
  'adminHero.title': 'Hero Image',
  'adminHero.subtitle': 'The homepage photograph and its credit. The photo is shown now; add the artwork, artist and art venue links here as soon as their ArtRouting pages exist — each link appears in the homepage credit when saved.',
  'adminHero.back': 'Back to Admin',
  'adminHero.live': 'Fully attributed — every credit link and the permission are recorded.',
  'adminHero.notLive': 'The photo is live, but {n} attribution item(s) are still missing — marked in red below.',
  'adminHero.required': 'Still missing',
  'adminHero.ok': 'Recorded',
  'adminHero.image': 'Photograph',
  'adminHero.imageHelp': 'The image shown at the top of the homepage. Upload a new one or keep the current file.',
  'adminHero.textPosition': 'Headline position on the photo',
  'adminHero.textRight': 'Right — keeps the artwork on the left clearly visible',
  'adminHero.textLeft': 'Left',
  'adminHero.creditName': 'Credit — artist name',
  'adminHero.creditNameHelp': 'Shown as “Artwork on easel by …”. Only this name is linked, to the artwork’s PIN.',
  'adminHero.artwork': 'Artwork PIN link',
  'adminHero.artworkHelp': 'The ArtRouting page of the artwork on the easel, e.g. https://artrouting.com/artworks/…',
  'adminHero.artist': 'Artist PIN link',
  'adminHero.artistHelp': 'The artist’s ArtRouting PIN or profile, e.g. https://artrouting.com/map/pin/… or /profiles/…',
  'adminHero.venue': 'Gallery / art venue PIN link',
  'adminHero.venueHelp': 'The PIN of the studio or gallery where the artwork is shown, e.g. https://artrouting.com/map/pin/…',
  'adminHero.linksTo': 'Links to',
  'adminHero.permission': 'Use permission received',
  'adminHero.permissionHelp': 'Confirm that the agreed permission to use this photograph (including the people and artworks in it) has been received.',
  'adminHero.save': 'Save hero image',
  'adminHero.savedLive': 'Saved. The photo is fully attributed.',
  'adminHero.savedNotLive': 'Saved. The photo is live; the items marked in red are still missing.',
  'adminHero.invalidLink': '{field}: this is not a link to an existing ArtRouting page of the right kind.',
  'adminHero.saveFailed': 'Could not save. Please try again.',
  'adminHero.superadminOnly': 'Only a superadmin can manage the hero image.',
  'adminHero.cardDesc': 'The homepage photograph and its credit links to the artwork, artist and gallery PINs.',
  'adminHero.cardStat': 'Credit links',
  'adminHero.cardCta': 'Manage',
  // Delegated Authorship, Exhibition Records, connected history
  'nav.authorship': 'Authorship',
  'authorship.loading': 'Loading authorship…',
  'authorship.title': 'Delegated Authorship',
  'authorship.subtitle': 'Let a named person help manage one of your roles — only within the permissions you both agree to. You keep full control and can revoke at any time.',
  'authorship.back': 'All agreements',
  'authorship.invite.open': 'Appoint a Delegated Author',
  'authorship.invite.role': 'Role to be managed',
  'authorship.invite.chooseRole': 'Choose a role…',
  'authorship.invite.authorEmail': 'Author’s registered ArtRouting email',
  'authorship.invite.authorEmailHelp': 'The person must already have an ArtRouting account',
  'authorship.invite.approvers': 'Additional required approvers (optional)',
  'authorship.invite.approversHelp': 'Registered emails, separated by commas — e.g. co-owners of a project',
  'authorship.invite.chooseAll': 'Choose Allow or Do not allow for every permission — nothing is pre-selected.',
  'authorship.invite.send': 'Send invitation',
  'authorship.roleType.artist': 'Artist',
  'authorship.roleType.venue': 'Art Venue',
  'authorship.roleType.explorer': 'Explorer',
  'authorship.perms.title': 'Permissions',
  'authorship.perms.ownerHelp': 'Role Owner: choose one option per row. Anything not allowed stays disabled.',
  'authorship.perms.authorHelp': 'Delegated Author: accept or decline every permission the owner allowed. You cannot add permissions the owner did not allow.',
  'authorship.perms.finalHelp': 'The final list: a permission is active only when the owner allowed it, the author accepted it and any required approver approved it.',
  'authorship.perms.action': 'Specific action',
  'authorship.perms.ownerChoice': 'Role Owner',
  'authorship.perms.authorChoice': 'Delegated Author',
  'authorship.perms.status': 'Result',
  'authorship.perm.sensitive': 'Sensitive',
  'authorship.perm.notYetAvailable': 'Not yet available on ArtRouting — agreeing records consent only and grants nothing until it launches.',
  'authorship.perm.granted': 'Granted',
  'authorship.perm.awaitingAuthor': 'Awaiting the author',
  'authorship.perm.awaitingApprover': 'Awaiting approval',
  'authorship.perm.disabled': 'Disabled',
  'authorship.choice.allow': 'Allow',
  'authorship.choice.deny': 'Do not allow',
  'authorship.choice.accept': 'Accept',
  'authorship.choice.decline': 'Decline',
  'authorship.rules.title': 'Rules — every box must be ticked',
  'authorship.rules.help': 'Both parties accept the same rules. Nothing becomes active until everyone required has agreed.',
  'authorship.final.owner': 'ROLE OWNER: I have selected the permissions above, read the rules, and authorise this named person ONLY within the allowed scope.',
  'authorship.final.author': 'DELEGATED AUTHOR: I have reviewed the exact permissions above, accepted or declined each, read the rules, and agree to the permitted scope.',
  'authorship.final.approver': 'ADDITIONAL REQUIRED APPROVER: I approve this same permission set and accept the rules.',
  'authorship.status.pending_owner': 'Awaiting the owner',
  'authorship.status.pending_author': 'Awaiting the author',
  'authorship.status.pending_approval': 'Awaiting approval',
  'authorship.status.active': 'Active',
  'authorship.status.declined': 'Declined',
  'authorship.status.revoked': 'Ended',
  'authorship.status.expired': 'Invitation expired',
  'authorship.list.needsYou': 'Waiting for your decision',
  'authorship.list.myAuthors': 'Authors on my roles',
  'authorship.list.iAuthor': 'Roles I help manage',
  'authorship.list.ended': 'Ended',
  'authorship.list.empty': 'No authorship agreements yet.',
  'authorship.list.ownerAuthor': 'Owner {owner} · Author {author}',
  'authorship.list.granted': '{n} granted',
  'authorship.rulesVersion': 'Rules version {v}',
  'authorship.party.owner': 'Role Owner',
  'authorship.party.author': 'Delegated Author',
  'authorship.party.approver': 'Required approver',
  'authorship.party.accepted': 'Accepted',
  'authorship.party.approved': 'Approved',
  'authorship.party.awaitingApproval': 'Not yet approved',
  'authorship.expires': 'This invitation expires on {date}.',
  'authorship.endedNote': 'Ended on {date}. Access stopped immediately; attribution and history remain.',
  'authorship.change.help': 'Reducing a permission takes effect immediately. A newly allowed permission starts only after the author (and any approver) accepts it again.',
  'authorship.change.save': 'Save permission changes',
  'authorship.change.saved': 'Permission changes saved.',
  'authorship.respond.submit': 'Accept my choices',
  'authorship.respond.done': 'Your answers are recorded.',
  'authorship.respond.declineAll': 'Decline the invitation',
  'authorship.respond.declineAdditions': 'Decline the new permissions',
  'authorship.respond.declined': 'Declined.',
  'authorship.owner.confirm': 'Confirm and send to the author',
  'authorship.owner.confirmed': 'Confirmed. The author now reviews the permissions.',
  'authorship.approver.approve': 'Approve this permission set',
  'authorship.approver.done': 'Your approval is recorded.',
  'authorship.revoke.revoke': 'Revoke access',
  'authorship.revoke.stepDown': 'Step down as author',
  'authorship.revoke.confirmOwner': 'Revoke this author’s access now? It takes effect immediately.',
  'authorship.revoke.confirmAuthor': 'Step down now? Your access ends immediately.',
  'authorship.revoke.done': 'Access has ended.',
  'authorship.revoke.help': 'Ending access never deletes attribution or the audit history.',
  'authorship.history': 'History',
  'authorship.system': 'ArtRouting',
  'authorship.action.invite': 'invited',
  'authorship.action.owner_confirm': 'owner confirmed',
  'authorship.action.accept': 'author accepted',
  'authorship.action.accept_additions': 'author accepted new permissions',
  'authorship.action.decline': 'author declined',
  'authorship.action.decline_additions': 'author declined new permissions',
  'authorship.action.approve': 'approved',
  'authorship.action.activate': 'became active',
  'authorship.action.permissions_changed': 'permissions changed',
  'authorship.action.revoke': 'ended',
  'authorship.err.generic': 'That did not work. Please try again.',
  'authorship.err.permission_not_chosen': 'Choose Allow or Do not allow for every permission.',
  'authorship.err.rules_not_accepted': 'Every rule and the final acceptance must be ticked.',
  'authorship.err.author_not_registered': 'No ArtRouting account uses that email address.',
  'authorship.err.author_is_owner': 'The Role Owner cannot be their own author.',
  'authorship.err.cannot_invite_self': 'You cannot invite yourself.',
  'authorship.err.already_exists': 'This person already has an open agreement for this role.',
  'authorship.err.tier_cap_reached': 'Your tier’s limit of Delegated Authors for this role is reached. See the pricing page.',
  'authorship.err.not_allowed': 'You are not allowed to do that.',
  'authorship.err.beyond_own_rights': 'You cannot grant a permission you do not hold yourself.',
  'authorship.err.approver_not_registered': 'An approver email has no ArtRouting account.',
  'authorship.err.approver_is_author': 'The author cannot also be an approver.',
  'authorship.err.permission_not_answered': 'Accept or decline every permission the owner allowed.',
  'authorship.err.wrong_state': 'This agreement cannot be changed in its current state.',
  'authorship.err.not_found': 'Agreement not found.',
  'authorship.err.role_not_found': 'That role no longer exists.',
  'authorship.err.cannot_edit_own_grant': 'You cannot change your own permissions.',
  'exhibitionRecords.title': 'Professional Exhibition Records',
  'exhibitionRecords.help': 'Connect your professional profile to existing ArtRouting exhibitions in which you had a recognised role. This links to the exhibition; it does not copy it or give editing rights.',
  'exhibitionRecords.usage': '{used} of {limit} records used',
  'exhibitionRecords.unlimited': '{used} records · no tier limit',
  'exhibitionRecords.notIncluded': 'Exhibition Records begin with Explorer Active.',
  'exhibitionRecords.notExplorer': 'Exhibition Records belong to the Explorer role. Add the Explorer role under Roles & registration.',
  'exhibitionRecords.search': 'Search exhibitions by title',
  'exhibitionRecords.role': 'Your role, e.g. Curator',
  'exhibitionRecords.add': 'Add record',
  'exhibitionRecords.remove': 'Remove',
  'exhibitionRecords.limitReached': 'Your tier’s Exhibition Record limit is reached.',
  'exhibitionRecords.contributors': 'Professional contributors',
  'artworkErr.artwork_limit_reached': 'Your tier’s Artwork PIN limit ({limit}) is reached. Existing artworks stay; upgrade for more.',
  'artworkErr.venue_artworks_not_included': 'Venue-managed Artwork PINs begin with Art Venue Active.',
  'provenanceEvent.status_change': 'Status change',
  'admin.paypal.plans.title': 'Subscription Plan IDs',
  'admin.paypal.plans.help': 'Every paid plan on the pricing page needs its own PayPal subscription plan. Create it under Subscriptions → Plans, then paste its Plan ID here:',
  'admin.paypal.plans.missingCount': '{n} of {total} plans still need a real PayPal Plan ID — marked in red below.',
  'admin.paypal.plans.allSet': 'All plans have a real PayPal Plan ID.',
  'admin.paypal.plans.artist': 'Artist plans',
  'admin.paypal.plans.venue': 'Art Venue plans',
  'admin.paypal.plans.explorer': 'Explorer plans',
  'admin.paypal.plans.heritage': 'Heritage plans',
  'admin.paypal.plans.heritageNote': 'Heritage is shown on the pricing page as “Coming soon”. Its Plan IDs are stored now and used once Heritage goes on sale.',
  'admin.paypal.plans.heritageActive': 'Heritage Active',
  'admin.paypal.plans.heritagePro': 'Heritage Pro',
  'admin.paypal.plans.markerEmpty': 'Not created yet — create this plan in PayPal and paste its Plan ID',
  'admin.paypal.plans.markerInvalid': 'Not a real PayPal Plan ID (expected P- followed by 20–30 letters and digits)',
  'admin.paypal.plans.markerOk': 'Real Plan ID',
  'admin.paypal.plans.placeholder': 'P-…',
  // Guided registration (/welcome), email verification, MV pilot
  'register.shortSubtitle': 'Join ArtRouting in a few minutes.',
  'register.step.account': 'Create your account: name, email and password.',
  'register.step.verify': 'Confirm your email address with the link we send you.',
  'register.step.rolePin': 'Choose your role and claim or create your first ArtRouting PIN.',
  'verifyEmail.checking': 'Confirming your email address…',
  'verifyEmail.doneTitle': 'Email address confirmed',
  'verifyEmail.doneBody': 'Thank you. Continue with your registration where you left off.',
  'verifyEmail.continue': 'Continue registration',
  'verifyEmail.signInToContinue': 'Sign in to continue',
  'verifyEmail.failedTitle': 'This link no longer works',
  'verifyEmail.failedBody': 'The confirmation link is invalid or has already been used. Request a new one from your registration page.',
  'verifyEmail.requestNew': 'Request a new link',
  'welcome.title': 'Set up My ArtRouting',
  'welcome.subtitle': 'A few short steps. Your progress is saved — you can leave and continue later.',
  'welcome.loading': 'Loading your registration…',
  'welcome.loadFailed': 'Your registration could not be loaded. Please try again.',
  'welcome.actionFailed': 'That did not work. Please try again.',
  'welcome.addRole': 'Add another role',
  'welcome.banner': 'Finish setting up your ArtRouting: {step}.',
  'welcome.banner.cta': 'Continue',
  'welcome.status.account_created': 'confirm your email address',
  'welcome.status.email_verified': 'choose your role',
  'welcome.status.pin_pending': 'claim or create your first PIN',
  'welcome.status.claim_under_review': 'your PIN claim is under review',
  'welcome.status.profile_pending': 'complete your minimum profile',
  'welcome.status.active': 'registration active',
  'welcome.status.mv_pilot_active': 'registration active',
  'welcome.step.email.title': 'Confirm your email address',
  'welcome.step.email.pending': 'We sent a confirmation link to your email address. Open it to continue — it brings you straight back here.',
  'welcome.step.email.done': 'Email address confirmed.',
  'welcome.step.email.resend': 'Send the link again',
  'welcome.step.email.resent': 'A new confirmation link is on its way.',
  'welcome.step.roles.title': 'Choose your role',
  'welcome.step.roles.help': 'Choose your main role first. One account can hold several roles, each with its own profile — you can add another at any time.',
  'welcome.step.roles.primary': 'Main role',
  'welcome.step.roles.save': 'Save roles',
  'welcome.step.roles.saved': 'Roles saved.',
  'welcome.step.pin.title': 'Your first ArtRouting PIN',
  'welcome.step.pin.help': 'Every participant starts with a real place on the map. If ArtRouting already lists you, claim your PIN. If not, create a new one.',
  'welcome.step.pin.fromLink': 'You started from this PIN:',
  'welcome.step.pin.claimTitle': 'View and claim your ArtRouting PIN',
  'welcome.step.pin.searchPlaceholder': 'Search by name or town',
  'welcome.step.pin.search': 'Search',
  'welcome.step.pin.noResults': 'No unclaimed PIN found for this search.',
  'welcome.step.pin.claim': 'Claim this PIN',
  'welcome.step.pin.claimNote': 'Claimed during registration.',
  'welcome.step.pin.createTitle': 'Not listed yet?',
  'welcome.step.pin.createHelp': 'Search first so no duplicate is created. If your place is not listed, create a new PIN and confirm its position on the map.',
  'welcome.step.pin.privacyArtist': 'Artists: a real studio or base address is needed, but you can hide your Studio PIN from the public.',
  'welcome.step.pin.searchFirst': 'Search first',
  'welcome.step.pin.create': 'Create a new PIN',
  'welcome.step.pin.done': 'Your first PIN: {name}.',
  'welcome.step.pin.review': 'Your claim for {name} is under review. We will let you know once it is confirmed.',
  'welcome.step.pin.view': 'View PIN',
  'welcome.step.area.title': 'Your area',
  'welcome.step.area.help': 'Explorers give a town and country or an approximate area. Your private address is never published.',
  'welcome.step.area.placeholder': 'e.g. Rostock, Germany',
  'welcome.step.area.save': 'Save area',
  'welcome.step.profile.title': 'Minimum profile',
  'welcome.step.profile.artist': 'Add your artist profile with your public name and your medium or discipline. Everything else can follow later.',
  'welcome.step.profile.gallery': 'Your venue PIN needs its public name, venue type and physical address. Add opening or appointment information where available.',
  'welcome.step.profile.explorer': 'Your public name and your area are all that is needed.',
  'welcome.step.profile.createArtist': 'Create artist profile',
  'welcome.step.profile.editPin': 'Complete venue PIN',
  'welcome.step.profile.done': 'Minimum profile complete.',
  'welcome.done.title': 'Your registration is active',
  'welcome.done.body': 'Everything needed is in place. Add the rest of your profile whenever you like.',
  'welcome.done.open': 'Open My ArtRouting',
  'welcome.done.continue': 'Continue where you started',
  'welcome.mv.title': 'Mecklenburg-Vorpommern pilot',
  'welcome.mv.body': 'Your ArtRouting presence is in Mecklenburg-Vorpommern: you have every ArtRouting capability free for one year from your registration date, in every role you hold.',
  'welcome.mv.dates': 'Started {start} · ends {end}',
  'pinDetail.viewAndClaim': 'View and claim your ArtRouting PIN',
  'pinDetail.viewAndClaimHelp': 'Is this your studio, venue or place? Create a free account and claim it — you come straight back to this PIN.',
  'pinDetail.registerToClaim': 'Register and claim',
  'pinDetail.orSignIn': 'Already registered? Sign in',
  'account.section.setup': 'Registration & roles',
  'account.setup.active': 'Your registration is active. Add another role or review your first PIN here.',
  'account.setup.open': 'Roles & registration',
  'admin.mvPilot.grant': 'Grant MV pilot',
  'admin.mvPilot.end': 'End MV pilot',
  'admin.mvPilot.granted': 'Mecklenburg-Vorpommern pilot granted for one year from registration.',
  'admin.mvPilot.ended': 'Mecklenburg-Vorpommern pilot ended.',
  'admin.mvPilot.failed': 'Could not change the pilot status.',
  'admin.mvPilot.help': 'Mecklenburg-Vorpommern pilot: maximum capabilities free for one year from the registration date. Granted automatically when the first PIN is in MV.',



  // ── Subscription ───────────────────────────────────
  'sub.title': 'My Subscription',
  'sub.yourPlan': 'Your Current Plan',
  'sub.status': 'Status',
  'sub.nextBilling': 'Next Billing',
  'sub.since': 'Since',
  'sub.paypalId': 'PayPal ID',
  'sub.adminAssigned': 'Your plan was assigned by an administrator. No PayPal subscription is required.',
  'sub.freeDesc': "You're on the free tier with basic map visibility. Upgrade to unlock full profile features and more.",
  'sub.cancelConfirm': 'Are you sure you want to cancel your subscription? You will lose access to premium features at the end of your current billing period.',
  'sub.cancelBtn': 'Cancel Subscription',
  'sub.cancelling': 'Cancelling...',
  'sub.suspended': 'Your subscription is suspended due to a payment issue. Please update your payment method in PayPal.',
  'sub.upgrade': 'Upgrade Your Plan',
  'sub.upgradePro': 'Upgrade to Pro',
  'sub.activated': 'Subscription activated successfully!',
  'sub.activateFailed': 'Failed to activate subscription. Please contact support.',
  'sub.cancelSuccess': 'Subscription cancelled. You retain access until the end of your billing period.',
  'sub.cancelFailed': 'Failed to cancel subscription',

  // ── Auth ───────────────────────────────────────────
  'auth.welcomeBack': 'Welcome Back',
  'auth.loginSubtitle': 'Log in to ArtRouting',
  'auth.createAccount': 'Create Account',
  'auth.registerSubtitle': 'Join ArtRouting to discover and share culture',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'you@example.com',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'Min. 8 characters',
  'auth.confirmPassword': 'Confirm Password',
  'auth.confirmPlaceholder': 'Re-enter password',
  'auth.name': 'Display Name',
  'auth.namePlaceholder': 'Your name',
  'auth.city': 'My City',
  'auth.cityPlaceholder': 'e.g. Amsterdam, Berlin, Cape Town',
  'auth.cityHelp': 'Sets your Near Me location on the map',
  'auth.login': 'Log In',
  'auth.loggingIn': 'Logging in...',
  'auth.register': 'Create Account',
  'auth.registering': 'Creating account...',
  'auth.noAccount': "Don't have an account?",
  'auth.registerHere': 'Register here',
  'auth.hasAccount': 'Already have an account?',
  'auth.loginHere': 'Log in here',
  'auth.fillAllFields': 'Please fill in all fields',
  'auth.passwordsNoMatch': 'Passwords do not match',
  'auth.passwordTooShort': 'Password must be at least 8 characters',
  'auth.agreeRequired': 'You must agree to the Privacy Policy and Terms of Use',
  'auth.iAmA': '',
  'auth.explorer': 'Explorer',
  'auth.explorerDesc': 'I want to discover art',
  'auth.artist': 'Artist',
  'auth.artistDesc': 'I create and showcase art',
  'auth.gallery': 'Gallery',
  'auth.galleryDesc': 'I represent a gallery or venue',
  'auth.agreeTo': 'I agree to the',
  'auth.and': 'and',

  // ── Map / Pin Types ────────────────────────────────
  'pin.gallery': 'Gallery',
  'pin.museum': 'Museum',
  'pin.art_centre': 'Art Centre',
  'pin.studio': 'Studio',
  'pin.venue': 'Venue',
  'pin.heritage': 'Heritage',
  'pin.supplier': 'Supplier',
  'pin.education': 'Education',
  'pin.residency': 'Residency',
  'pin.public_art': 'Public Art',
  'pin.cultural_site': 'Cultural Site',
  'pin.collection': 'Collection',
  'map.search': 'Search pins...',
  'map.filters': 'Filters',
  'map.toggle': 'Toggle',
  'map.nearMe': 'Near Me',
  'map.allPins': 'All Pins',
  'map.backToMap': 'Back to Map',

  // ── Pin Detail ─────────────────────────────────────
  'pinDetail.loading': 'Loading pin...',
  'pinDetail.notFound': 'Pin not found',
  'pinDetail.deleteConfirm': 'Delete this pin? This cannot be undone.',
  'pinDetail.claimSubmitted': 'Claim submitted! An admin will review it.',
  'pinDetail.releaseConfirm': 'Release this location? You will lose ownership and it will become unclaimed.',
  'pinDetail.verified': 'Verified',
  'pinDetail.about': 'About',
  'pinDetail.edit': 'Edit',
  'pinDetail.delete': 'Delete',
  'pinDetail.claim': 'Claim this location',
  'pinDetail.release': 'Release',
  'pinDetail.openingHours': 'Opening Hours',
  'pinDetail.contact': 'Contact',
  'pinDetail.website': 'Website',
  'pinDetail.address': 'Address',
  'pinDetail.amenities': 'Amenities',
  'pinDetail.artworks': 'Artworks',
  'pinDetail.historicalPeriod': 'Historical Period',
  'pinDetail.historicalDescription': 'Historical Description',
  'pinDetail.foundation': 'Foundation',
  'pinDetail.officialWebsite': 'Official Website',
  'pinDetail.verificationStatus': 'Verification Status',
  'pinDetail.nearbyCulturalLocations': 'Nearby Cultural Locations',
  'pinDetail.artRouteConnection': 'Art Route Connection',
  'pinDetail.socialMedia': 'Social Media',
  'pinDetail.gallery': 'Gallery',
  'pinDetail.claimPending': 'Claim Pending',
  'pinDetail.claimPendingMsg': 'Your claim is pending admin review.',
  'pinDetail.galleryImageAlt': 'Gallery image',

  // Heritage subtypes
  'heritage.artist_estate': 'Artist Estate',
  'heritage.historic_studio': 'Historic Studio',
  'heritage.birthplace': 'Birthplace',
  'heritage.burial_site': 'Burial Site',
  'heritage.cultural_movement_site': 'Cultural Movement Site',
  'heritage.historic_exhibition': 'Historic Exhibition',

  // Verification statuses
  'verification.unverified': 'Unverified',
  'verification.verified': 'Verified',
  'verification.documented': 'Documented',
  'verification.community': 'Community Suggested',

  // Amenities
  'amenity.parking': 'Parking',
  'amenity.wheelchair': 'Wheelchair Access',
  'amenity.cafe': 'Caf\u00e9',
  'amenity.shop': 'Shop',
  'amenity.restrooms': 'Restrooms',
  'amenity.wifi': 'Wi-Fi',
  'amenity.guided_tours': 'Guided Tours',
  'amenity.audio_guide': 'Audio Guide',
  'amenity.lockers': 'Lockers',
  'amenity.garden': 'Garden',

  // ── Discover ───────────────────────────────────────
  'discover.all': 'All',
  'discover.places': 'Places',
  'discover.heritage': 'Heritage',
  'discover.events': 'Events',
  'discover.articles': 'Articles',
  'discover.routes': 'Routes',
  'discover.artists': 'Artists',
  'discover.artworks': 'Artworks',
  'discover.place': 'place',
  'discover.places_plural': 'places',
  'discover.event': 'event',
  'discover.events_plural': 'events',
  'discover.article': 'article',
  'discover.articles_plural': 'articles',
  'discover.route': 'route',
  'discover.routes_plural': 'routes',
  'discover.artist': 'artist',
  'discover.artists_plural': 'artists',
  'discover.artwork': 'artwork',
  'discover.artworks_plural': 'artworks',
  'discover.heritageSite': 'heritage site',
  'discover.heritageSites': 'heritage sites',

  // ── Events ─────────────────────────────────────────
  'event.exhibition': 'Exhibition',
  'event.opening': 'Opening',
  'event.art_fair': 'Art Fair',
  'event.workshop': 'Workshop',
  'event.open_studio': 'Open Studio',
  'event.performance': 'Performance',
  'event.festival': 'Festival',
  'event.talk': 'Talk / Lecture',
  'event.guided_tour': 'Guided Tour',
  'event.dateTBA': 'Date TBA',
  'event.backToEvents': 'Back to Events',

  // Months
  'month.0': 'January', 'month.1': 'February', 'month.2': 'March',
  'month.3': 'April', 'month.4': 'May', 'month.5': 'June',
  'month.6': 'July', 'month.7': 'August', 'month.8': 'September',
  'month.9': 'October', 'month.10': 'November', 'month.11': 'December',

  // ── Profiles ───────────────────────────────────────
  'profile.backToArtists': 'Back to Artists',
  'profile.notFound': 'Profile not found',
  'profile.deleteConfirm': 'Are you sure you want to delete this profile? This cannot be undone.',
  'profile.networkError': 'Network error \u2014 please try again.',

  // ── Artworks ───────────────────────────────────────
  'artwork.backToArtworks': 'Back to Artworks',
  'artwork.notFound': 'Artwork not found',

  // ── Routes ─────────────────────────────────────────
  'route.backToRoutes': 'Back to Routes',
  'route.notFound': 'Route not found',

  // ── Bookmarks ──────────────────────────────────────
  'bookmarks.title': 'Bookmarks',
  'bookmarks.loginRequired': 'Log in to view your saved items.',
  'bookmarks.loading': 'Loading bookmarks...',
  'bookmarks.savedItem': 'saved item',
  'bookmarks.savedItems': 'saved items',
  'bookmarks.removeError': 'Error removing bookmark',
  'bookmarks.pins': 'Pins',
  'bookmarks.routes': 'Routes',
  'bookmarks.artworks': 'Artworks',
  'bookmarks.articles': 'Articles',
  'bookmarks.events': 'Events',
  'bookmarks.profiles': 'Profiles',
  'bookmarks.empty': 'No saved items yet',

  // ── Tiers ──────────────────────────────────────────

  // ── Common ─────────────────────────────────────────
  // Admin → Tier Names (superadmin renames tiers site-wide)
  'admin.backToDashboard': '← Back to dashboard',
  // Admin → Tier Pricing (superadmin sets what each tier costs)
  'admin.tierPricing.title': 'Tier Pricing',
  'admin.tierPricing.intro': 'Set what each tier costs. The public pricing page and the PayPal settings labels quote whatever you type here. Both languages are required — the price line carries words, not only numbers.',
  'admin.tierPricing.paypalNote': 'This changes what ArtRouting says a tier costs, not what PayPal charges. To change the amount actually billed, create a new plan in PayPal and paste its id into',
  'admin.tierPricing.paypalLink': 'PayPal Settings',
  'admin.tierPricing.priceEn': 'Price (English)',
  'admin.tierPricing.priceDe': 'Price (German)',
  'admin.tierPricing.periodEn': 'Period (English)',
  'admin.tierPricing.periodDe': 'Period (German)',
  'admin.tierPricing.preview': 'Shows as',
  'admin.tierPricing.saved': 'Saved — the new price is live across the site',
  'admin.tierPricing.saveFailed': 'Could not save that price',
  'admin.tierPricing.loadFailed': 'Could not load the tier prices',
  'admin.tierPricing.reset': 'Reset all prices to the shipped values',
  'admin.tierPricing.resetConfirm': 'Reset every tier price back to the shipped default? Your own prices will be lost.',
  'admin.tierPricing.superadminOnly': 'Only a superadmin can change tier pricing.',
  'admin.tierNames.title': 'Tier Names',
  'admin.tierNames.intro': 'Rename any tier here. Whatever you type is what the whole site shows — pricing page, tier badges, tier editor, admin lists. Both languages are required.',
  'admin.tierNames.nameEn': 'Name (English)',
  'admin.tierNames.nameDe': 'Name (German)',
  'admin.tierNames.labelEn': 'Caption (English)',
  'admin.tierNames.labelDe': 'Caption (German)',
  'admin.tierNames.saved': 'Saved — the new name is live across the site',
  'admin.tierNames.saveFailed': 'Could not save that name',
  'admin.tierNames.loadFailed': 'Could not load the tier names',
  'admin.tierNames.reset': 'Reset all tiers to the shipped names',
  'admin.tierNames.resetConfirm': 'Reset every tier name back to the shipped default? Your own wording will be lost.',
  'admin.tierNames.superadminOnly': 'Only a superadmin can rename tiers.',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.saving': 'Saving…',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.create': 'Create',
  'common.loading': 'Loading...',
  'common.error': 'An error occurred',
  'common.back': 'Back',
  'common.search': 'Search...',
  'common.noResults': 'No results found',
  'common.perMonth': '/month',
  'common.viewAll': 'View All',
  'common.readMore': 'Read more',
  'common.showMore': 'Show more',
  'common.showLess': 'Show less',
  'common.preview': 'Preview',
  'common.upload': 'Upload',
  'common.uploading': 'Uploading...',
  'common.selectImage': 'Please select an image file',
  'common.imageTooLarge': 'Image must be under 10MB',
  'common.uploadFailed': 'Upload failed',

  // ── Legal Pages ────────────────────────────────────
  'legal.privacyTitle': 'Privacy Policy',
  'legal.termsTitle': 'Terms of Use',
  'legal.cookiesTitle': 'Cookie Policy',
  'legal.lastUpdated': 'Last updated',
  'legal.backToHome': 'Back to Home',

  // ── Error Boundary ─────────────────────────────────
  'error.newVersion': 'A new version is available.',
  'error.reload': 'Reload',

  // ── Articles / ArtRadar ────────────────────────────
  'articles.title': 'ArtRadar',
  'articles.subtitle': 'Stories, highlights, and cultural signals',
  'articles.readArticle': 'Read article',
  'articles.backToArticles': 'Back to ArtRadar',
  'articles.noArticles': 'No articles published yet.',
  'articles.published': 'Published',
  'articles.by': 'by',

  // ── Submissions ────────────────────────────────────
  'submissions.title': 'Submissions',
  'submissions.new': 'New Submission',
  'submissions.loading': 'Loading submissions...',
  'submissions.empty': 'No submissions yet.',

  // ── Docs ───────────────────────────────────────────
  'docs.title': 'Documentation',
  'docs.loading': 'Loading documentation...',

  // ── My Pages ───────────────────────────────────────
  'myPins.title': 'My Pins',
  'myPins.createPin': 'Create Pin',
  'myPins.browseMap': 'Browse Map',
  'myPins.noPins': 'No pins yet',
  'myPins.noPinsDesc': 'Create a new pin or browse the map to find and claim venues as your own.',
  'myPins.all': 'All',
  'myPins.loading': 'Loading your pins...',

  'myProfile.title': 'My Profile',
  'myProfile.noProfile': "You don't have a profile yet",
  'myProfile.noProfileDesc': 'Create your artist profile to showcase your work, get discovered on the map, and build your portfolio.',
  'myProfile.createProfile': 'Create Profile',
  'myProfile.guidedSetup': 'Guided Setup',
  'myProfile.importFromUrl': 'Import from URL',
  'myProfile.editProfile': 'Edit Profile',
  'myProfile.viewPublic': 'View Public Profile',

  'myArtworks.title': 'My Artworks',
  'myArtworks.addArtwork': 'Add Artwork',
  'myArtworks.noArtworks': "You haven't added any artworks yet",
  'myArtworks.noArtworksDesc': 'Add artworks to showcase your portfolio.',
  'myArtworks.importFromWeb': 'Import from Website',
  'myArtworks.loading': 'Loading your artworks...',

  'myRoutes.title': 'My Routes',
  'myRoutes.createRoute': 'Create Route',
  'myRoutes.noRoutes': 'No routes yet',
  'myRoutes.noRoutesDesc': 'Create a cultural route to connect places and guide visitors.',
  'myRoutes.loading': 'Loading your routes...',

  // ── List Pages ─────────────────────────────────────
  'profilesList.title': 'Artists & Curators',
  'profilesList.subtitle': 'Discover artists, curators, and creative professionals on the map.',
  'profilesList.loading': 'Loading profiles...',
  'profilesList.noResults': 'No profiles found',
  'profilesList.noResultsDesc': 'Be the first to create a profile.',
  'profilesList.search': 'Search artists...',
  'profilesList.allCountries': 'All Countries',
  'profilesList.artistsTitle': 'Artists & Collectives',
  'profilesList.artistsSubtitle': 'Artists, collectives, and other creators on ArtRouting. Browse to find collaborators or curatorial clients.',
  'profilesList.artistsSearchPlaceholder': 'Search artists by name, city, bio, medium...',
  'profilesList.noArtists': 'No artists match this search.',
  'profilesList.curatorsTitle': 'Curators',
  'profilesList.curatorsSubtitle': 'Curators (galleries, agents, managers) you can engage to manage your profile, artworks, and articles.',
  'profilesList.curatorsSearchPlaceholder': 'Search curators by name, specialty, region, language...',
  'profilesList.noCurators': 'No curators yet match this search.',
  'profilesList.createCuratorProfile': 'Create my Cultural Amplifier profile',
  'profilesList.amplifiersTitle': 'Cultural Amplifiers',
  'profilesList.amplifiersSubtitle': 'Curators, journalists, collectors, critics, researchers and other professionals who amplify and connect the visual arts ecosystem.',
  'profilesList.amplifiersSearchPlaceholder': 'Search amplifiers by name, specialty, region, language...',
  'profilesList.noAmplifiers': 'No Cultural Amplifiers yet match this search.',
  'account.section.amplifier': 'Cultural Amplifier',
  'account.section.amplifierDesc': 'As an {tier} user you can act as a Cultural Amplifier — a professional who supports, documents, organizes or otherwise shapes the visual arts ecosystem around artists. Pick your role below.',
  'account.amplifier.toggle': 'I want to act as a Cultural Amplifier',
  'account.amplifier.roleLabel': 'My role',
  'account.amplifier.roleHint': 'Your role appears next to your name on the artists and profiles you support.',
  // Public messaging roles — who someone is, never what they subscribe to.
  'role.artist': 'Artist',
  'role.gallery': 'Gallery',
  'role.explorer': 'Explorer',
  'amplifier.role.curator': 'Curator',
  'amplifier.role.journalist': 'Journalist',
  'amplifier.role.collector': 'Collector',
  'amplifier.role.critic': 'Critic',
  'amplifier.role.researcher': 'Researcher',
  'amplifier.role.historian': 'Historian',
  'amplifier.role.art_advisor': 'Art Advisor',
  'amplifier.role.organizer': 'Organizer',
  'amplifier.role.editor_writer': 'Editor / Writer',

  'artworksList.title': 'Artworks',
  'artworksList.subtitle': 'Explore artworks from artists around the world.',
  'artworksList.loading': 'Loading artworks...',
  'artworksList.noResults': 'No artworks yet',
  'artworksList.noResultsDesc': 'Be the first to register an artwork.',
  'artworksList.registerArtwork': 'Register Artwork',

  'routesList.title': 'Cultural Routes',
  'routesList.subtitle': 'Follow curated routes through art districts, open studios, and exhibition trails.',
  'routesList.loading': 'Loading routes...',
  'routesList.noResults': 'No routes found',
  'routesList.search': 'Search routes...',
  'routesList.allTypes': 'All Types',
  'routesList.allCountries': 'All Countries',

  'eventsList.title': 'Events',
  'eventsList.subtitle': 'Exhibitions, openings, workshops, and cultural happenings.',
  'eventsList.loading': 'Loading events...',
  'eventsList.noResults': 'No events found',
  'eventsList.noResultsDesc': 'Check back soon for upcoming events.',
  'eventsList.search': 'Search events...',
  'eventsList.allTypes': 'All Types',
  'eventsList.upcoming': 'Upcoming',
  'eventsList.past': 'Past',
  'eventsList.all': 'All',
  'eventsList.pastEvent': 'Past Event',
  'eventsList.ended': 'Ended',
  'eventsList.happeningNow': 'Happening now',
  'eventsList.thisWeek': 'This week',
  'eventsList.thisMonth': 'This month',
  'eventsList.laterThisYear': 'Later this year',
  'eventsList.allTime': 'All time',
  'eventsList.showArchive': 'Show archive',
  'eventsList.hideArchive': 'Hide archive',
  'eventsList.archiveSection': 'Archive',
  'footer.impressum': 'Impressum',
  'legal.impressumTitle': 'Impressum',
  'legal.impressumSubtitle': 'Information pursuant to § 5 DDG and § 18 MStV',
  'legal.impressumProject': 'A project of:',
  'legal.impressumRepresentedBy': 'Represented by',
  'legal.impressumAddress': 'Address',
  'legal.impressumContact': 'Contact',
  'legal.impressumEmailLabel': 'Email',
  'legal.impressumRegister': 'Commercial Register',
  'legal.impressumRegisterTbd': 'Commercial register entry to be added.',
  'legal.impressumResponsible': 'Responsible for journalistic-editorial content pursuant to § 18 Abs. 2 MStV',
  'legal.impressumDisclaimer': 'Liability Disclaimer',
  'legal.impressumDisclaimerBody': 'As a service provider we are responsible for our own content on these pages according to general laws. We are, however, not obliged to monitor transmitted or stored third-party information. Obligations to remove or block the use of information under general laws remain unaffected.',

  // ── Discover Page ──────────────────────────────────
  'discover.title': 'Discover',
  'discover.subtitle': 'Explore the cultural map',
  'discover.search': 'Search places, artists, artworks...',
  'discover.loading': 'Discovering...',
  'discover.noResults': 'No results found',

  // ── Article Categories ─────────────────────────────
  'articleCat.gallery_spotlight': 'Gallery Spotlight',
  'articleCat.artist_profile': 'Artist Profile',
  'articleCat.exhibition_review': 'Exhibition Review',
  'articleCat.cultural_insight': 'Cultural Insight',
  'articleCat.route_guide': 'Route Guide',
  'articleCat.news': 'News',
  'articleCat.event': 'Event',
  'articleCat.opinion': 'Opinion',
  'articleCat.interview': 'Interview',
  'articleCat.opportunity': 'Opportunity',
  'articleCat.educational_guide': 'Educational Guide',
  'articleCat.heritage_story': 'Heritage Story',

  // ── Route Types ────────────────────────────────────
  'routeType.art_trail': 'Art Trail',
  'routeType.heritage': 'Heritage',
  'routeType.walking': 'Walking',
  'routeType.cycling': 'Cycling',
  'routeType.driving': 'Driving',
  'routeType.cultural': 'Cultural',
  'routeType.mixed': 'Mixed',
  'routeType.my_route': 'User Route',

  // ── Form Labels (shared) ───────────────────────────
  'form.title': 'Title',
  'form.name': 'Name',
  'form.displayName': 'Display Name',
  'form.description': 'Description',
  'form.bio': 'Bio',
  'form.medium': 'Medium',
  'form.year': 'Year',
  'form.dimensions': 'Dimensions',
  'form.website': 'Website',
  'form.city': 'City',
  'form.country': 'Country',
  'form.address': 'Address',
  'form.latitude': 'Latitude',
  'form.longitude': 'Longitude',
  'form.visibility': 'Visibility',
  'form.status': 'Status',
  'form.type': 'Type',
  'form.category': 'Category',
  'form.tags': 'Tags',
  'form.image': 'Image',
  'form.startDate': 'Start Date',
  'form.endDate': 'End Date',
  'form.venue': 'Venue',
  'form.price': 'Price',
  'form.free': 'Free',
  'form.selectType': 'Select type',
  'form.selectCountry': 'Select country',
  'form.saving': 'Saving...',
  'form.create': 'Create',
  'form.update': 'Update',
  'form.cancel': 'Cancel',
  'form.saveChanges': 'Save Changes',
  'form.creating': 'Creating...',
  'form.delete': 'Delete',
  'form.confirmDelete': 'Are you sure? This cannot be undone.',
  'form.yesDelete': 'Yes, Delete',
  'form.release': 'Release',
  'form.location': 'Location',
  'form.submitForReview': 'Submit for Review',
  'form.publish': 'Publish',
  'form.draft': 'Draft',
  'form.published': 'Published',
  'form.archived': 'Archived',
  'form.pending': 'Pending',
  'form.approved': 'Approved',
  'form.rejected': 'Rejected',

  // ── Profile Types ──────────────────────────────────
  'profileType.artist': 'Artist',
  'profileType.collective': 'Collective',
  'profileType.curator': 'Curator',
  'profileType.gallery': 'Gallery',

  // ── Create/Edit Pages ──────────────────────────────
  'createProfile.title': 'Create Profile',
  'editProfile.title': 'Edit Profile',
  'createArtwork.title': 'Create Artwork',
  'editArtwork.title': 'Edit Artwork',
  'createEvent.title': 'Create Event',
  'editEvent.title': 'Edit Event',
  'createRoute.title': 'Create Route',
  'editRoute.title': 'Edit Route',
  'createPin.title': 'Create Pin',
  'editPin.title': 'Edit Pin',

  // ── Route Detail ───────────────────────────────────
  'routeDetail.stops': 'Stops',
  'routeDetail.distance': 'Distance',
  'routeDetail.duration': 'Duration',
  'routeDetail.difficulty': 'Difficulty',
  'routeDetail.startRoute': 'Start Route',

  // ── Provenance ─────────────────────────────────────
  'provenance.title': 'Provenance',
  'provenance.history': 'History',
  'provenance.claimOwnership': 'Claim Ownership',
  'provenance.verified': 'Verified',
  'provenance.certificate': 'Certificate of Provenance',
  'provenance.verifiedChain': 'ArtRouting — Verified Chain of Ownership',
  'provenance.notFound': 'Artwork Not Found',
  'provenance.transfer': 'Transfer Ownership',
  'provenance.printCert': 'Print Certificate',
  'provenance.noEvents': 'No provenance events recorded yet.',
  'provenance.disputed': 'Disputed',
  'provenance.unverified': 'Unverified',
  'provenance.currentOwner': 'Current Owner',
  'provenance.ownershipHistory': 'Ownership History',
  'provenance.timeline': 'Provenance Timeline',
  'provenance.claimBtn': 'I Own This Artwork',
  'provenance.howAcquired': 'How did you acquire this artwork?',
  'provenance.selectMethod': 'Select...',
  'provenance.dateAcquired': 'Date Acquired',
  'provenance.notes': 'Notes / Description',
  'provenance.noRecords': 'No Provenance Records Yet',
  'provenance.allQrLink': 'All QR codes below link to:',
  'provenance.permanent': 'Permanent — this link never changes',
  'provenance.qrGenerating': 'QR Generating...',
  'provenance.reloadPage': 'Reload page',

  // Provenance event types
  'provenanceEvent.creation': 'Created',
  'provenanceEvent.created': 'Created',
  'provenanceEvent.sale': 'Sale',
  'provenanceEvent.gift': 'Gift',
  'provenanceEvent.inheritance': 'Inheritance',
  'provenanceEvent.commission': 'Commission',
  'provenanceEvent.exhibition_loan': 'Exhibition Loan',
  'provenanceEvent.exhibition_return': 'Exhibition Return',
  'provenanceEvent.consignment': 'Consignment',
  'provenanceEvent.auction': 'Auction',
  'provenanceEvent.donation': 'Donation',
  'provenanceEvent.theft': 'Theft',
  'provenanceEvent.theft_reported': 'Theft Reported',
  'provenanceEvent.recovery': 'Recovery',
  'provenanceEvent.recovered': 'Recovered',
  'provenanceEvent.restoration': 'Restoration',
  'provenanceEvent.appraisal': 'Appraisal',
  'provenanceEvent.found_claimed': 'Found/Claimed',
  'provenanceEvent.location_change': 'Location Change',
  'provenanceEvent.deaccession': 'Deaccession',
  'provenanceEvent.exhibition': 'Exhibition',
  'provenanceEvent.loan': 'Loan',
  'provenanceEvent.return': 'Return',
  'provenanceEvent.other': 'Other',

  // Transfer form
  'transfer.newOwnerName': 'New Owner Name',
  'transfer.newOwnerEmail': 'New Owner Email',
  'transfer.type': 'Transfer Type',
  'transfer.date': 'Transfer Date',
  'transfer.notes': 'Notes',
  'transfer.submitting': 'Transferring...',

  // ── Lens ─────────────────────────────────────────
  'lens.notFound': 'Not Found',
  'lens.notFoundDesc': 'This item could not be found on ArtRouting.',
  'lens.viewProvenance': 'View Provenance',
  'lens.provenanceDesc': 'Chain of ownership and history',
  'lens.location': 'Location',
  'lens.discoveredVia': 'Discovered via ArtRouting',
  'lens.entityArtwork': 'Artwork',
  'lens.entityPin': 'Location',
  'lens.entityProfile': 'Artist',
  'lens.entityRoute': 'Cultural Route',
  'lens.entityEvent': 'Event',
  'lens.qrLinksTo': 'This QR code links to:',
  'lens.qrIdentical': 'All QR codes above are identical — pick the size that fits your use.',
  'lens.sizeMedium': 'Medium',

  // ── Consignment ──────────────────────────────────
  'consignment.yourPrice': 'Your price:',
  'consignment.galleryPrice': 'Gallery price:',
  'consignment.artistAskingPrice': 'Artist asking price:',
  'consignment.galleryDisplayPrice': 'Gallery Display Price',
  'consignment.notesOptional': 'Notes (optional)',
  'consignment.accept': 'Accept',
  'consignment.reject': 'Reject',
  'consignment.withdraw': 'Withdraw',
  'consignment.remove': 'Remove',
  'consignment.inboxTitle': 'Submission Inbox',
  'consignment.inboxDesc': 'Review artwork submissions from artists. Accept with your gallery price or reject.',
  'consignment.myTitle': 'My Submissions',
  'consignment.submitToEvent': 'Submit to Event',
  'consignment.selectEvent': 'Select an event...',
  'consignment.askingPrice': 'Your Asking Price',
  'consignment.submitting': 'Submitting...',
  'consignment.submit': 'Submit',
  'consignment.submitted': 'Claim submitted!',

  // ── Artwork Detail ───────────────────────────────
  'artworkDetail.medium': 'Medium',
  'artworkDetail.dimensions': 'Dimensions',
  'artworkDetail.yearCreated': 'Year Created',
  'artworkDetail.location': 'Location',
  'artworkDetail.price': 'Price',
  'artworkDetail.availability': 'Availability',
  'artworkDetail.contact': 'Contact',
  'artworkDetail.claimArtwork': 'Claim this Artwork',
  'artworkDetail.claimSubmitted': 'Claim submitted!',
  'artworkDetail.saved': 'Saved',
  'artworkDetail.anonymous': 'Anonymous',
  'artworkDetail.available': 'Available',
  'artworkDetail.sold': 'Sold',
  'artworkDetail.onLoan': 'On Loan',
  'artworkDetail.notForSale': 'Not for Sale',
  'artworkDetail.salesContact': 'Sales Contact',
  'artworkDetail.pinLocation': 'Pin / Location',
  'artworkDetail.provenance': 'Provenance',
  'artworkDetail.condition': 'Condition',

  // ── Profile Detail ───────────────────────────────
  'profileDetail.hostPins.title': 'Galleries & studios',
  'profileDetail.claimProfile': 'Claim this Profile',
  'profileDetail.claimSubmitted': 'Claim submitted!',
  'profileDetail.artisticStyle': 'Artistic Style:',
  'profileDetail.studioHours': 'Studio Hours:',
  'profileDetail.saved': 'Saved',

  // ── Article Detail ───────────────────────────────
  'articleDetail.moreFrom': 'More from ArtRadar',
  'articleDetail.notFound': 'Article Not Found',
  'articleDetail.saved': 'Saved',

  // ── Map Page ─────────────────────────────────────
  'map.viewDetails': 'View Details',
  'map.partOfRoute': 'Part of a route',
  'map.viewRoute': 'View Route',
  'map.youAreHere': 'You are here',
  'map.eventFilter.label': 'Events on Map',
  'map.eventFilter.all': 'All time',
  'map.eventFilter.now': 'Now',
  'map.eventFilter.week': 'This week',
  'map.eventFilter.month': 'This month',
  'map.eventFilter.later': 'Later',
  'map.pastelCommunity': 'Pastel = Community',
  'map.brightVerified': 'Bright = Owner Verified',

  // ── Discover Page Extras ─────────────────────────
  'discover.showAllTypes': 'Show all types',
  'discover.allCountries': 'All countries',
  'discover.clearSearch': 'Clear search',
  'discover.loadMore': 'Load More',
  'discover.locating': 'Locating...',
  'discover.nearMeOn': 'Near Me ON',
  'discover.nearMe': 'Near Me',
  'discover.browsing': 'Browsing',
  'discover.items': 'items',
  'discover.item': 'item',
  'discover.within': 'within',
  'discover.km': 'km',
  'discover.found': 'Found',
  'discover.resultsFor': 'results for',
  'discover.resultFor': 'result for',

  // ── Events List Extras ───────────────────────────
  'eventsList.dateTBA': 'Date TBA',
  'eventsList.locating': 'Locating...',
  'eventsList.nearMeOn': 'Near Me ON',
  'eventsList.nearMe': 'Near Me',
  'eventsList.loadMore': 'Load More',
  'eventsList.remaining': 'remaining',

  // ── Route List Extras ────────────────────────────
  'routesList.easy': 'Easy',
  'routesList.moderate': 'Moderate',
  'routesList.challenging': 'Challenging',

  // ── Submission Pages ─────────────────────────────
  'submission.newPin': 'New Pin',
  'submission.updatePin': 'Update Pin',
  'submission.newEvent': 'New Event',
  'submission.newRoute': 'New Route',
  'submission.newArticle': 'New Article',
  'submission.emptyDesc': "You haven't submitted anything yet",
  'submission.untitled': 'Untitled',
  'submission.needsChanges': 'Needs Changes',
  'submission.notFound': 'Submission Not Found',
  'submission.region': 'Region',

  // ── Bookmarks Extras ─────────────────────────────
  'bookmarks.emptyDesc': 'Save items from the map, routes, or articles to find them here.',


  // ── Docs ─────────────────────────────────────────
  'docs.saving': 'Saving...',
  'docs.save': 'Save',
  'docs.documents': 'Documents',

  // ── Pin Edit/Create Extras ───────────────────────
  'pinForm.phone': 'Phone',
  'pinForm.email': 'Email',
  'pinForm.openingHours': 'Opening Hours',
  'pinForm.entryFee': 'Entry Fee',
  'pinForm.languages': 'Languages',
  'pinForm.mission': 'Gallery / Venue Mission',
  'pinForm.culturalSignificance': 'Cultural Significance',
  'pinForm.historicalNotes': 'Historical Notes',
  'pinForm.bestTimeToVisit': 'Best Time to Visit',
  'pinForm.deletePin': 'Delete Pin',
  'adminUsers.deleteUser': 'Delete + all data',
  'adminUsers.deleteUserTitle': 'Permanently delete this user and everything connected to them (GDPR)',
  'adminUsers.deleteUserConfirm': 'GDPR DELETE: permanently remove {name} ({email}) and ALL their data — pins, artworks, profiles, routes, events, articles, bookmarks and account? This cannot be undone.',
  'adminUsers.deleteUserDone': 'User and all data deleted.',
  'adminUsers.deleteUserPartial': 'User deleted but references still remain in:',
  'adminUsers.deleteUserError': 'Failed to delete user',
  'adminFreePro.cardTitle': 'Free-Pro Report',
  'adminFreePro.cardDesc': 'Every user on the automatic free-Pro trial — how long they have had it and when it lapses. Use it to email them to convert or let them fall back to free.',
  'adminFreePro.cardStat': 'On trial',
  'adminFreePro.cardCta': 'Generate →',
  'adminFreePro.title': 'Free-Pro Report',
  'adminFreePro.subtitle': 'Users on the automatic free-Pro trial granted at registration. Email them to convert to a paid tier — or let the trial lapse back to free.',
  'adminFreePro.backToAdmin': '← Back to Admin',
  'adminFreePro.loading': 'Generating report…',
  'adminFreePro.error': 'Failed to load the free-Pro report.',
  'adminFreePro.empty': 'No users are currently on a free-Pro trial.',
  'adminFreePro.statTotal': 'On free-Pro trial',
  'adminFreePro.statExpiringSoon': 'Lapsing within 7 days',
  'adminFreePro.statExpired': 'Already lapsed',
  'adminFreePro.generatedAt': 'Generated',
  'adminFreePro.copyEmails': 'Copy email list',
  'adminFreePro.copied': 'Copied!',
  'adminFreePro.downloadCsv': 'Download CSV',
  'adminFreePro.refresh': 'Refresh',
  'adminFreePro.colName': 'Name',
  'adminFreePro.colEmail': 'Email',
  'adminFreePro.colType': 'Type',
  'adminFreePro.colRegistered': 'Registered',
  'adminFreePro.colDaysOnPro': 'Days on free-Pro',
  'adminFreePro.colTrialTier': 'Trial tier',
  'adminFreePro.colExpires': 'Trial ends',
  'adminFreePro.colDaysLeft': 'Days left',
  'adminFreePro.colStatus': 'Status',
  'adminFreePro.statusActive': 'Active',
  'adminFreePro.statusExpired': 'Lapsed',
  'adminFreePro.daysSuffix': 'd',
  'superadmin.deleteItem': 'Delete (admin)',
  'superadmin.deleteItemConfirm': 'Permanently delete this item? This cannot be undone.',
  'superadmin.deleteError': 'Delete failed',
  'superadmin.wipeOwner': 'Delete owner + all data',
  'superadmin.wipeOwnerConfirm': 'GDPR DELETE: permanently remove {name} and ALL their data — pins, artworks, profiles, routes, events, articles, bookmarks and account? This cannot be undone.',
  'superadmin.wipeOwnerDone': 'Owner and all their data deleted.',
  'superadmin.wipeOwnerPartial': 'Owner deleted but references still remain in:',
  'pinForm.createPin': 'Create Pin',
  'pinForm.amenities': 'Amenities',
  'pinForm.associatedArtist': 'Associated Artist',
  'pinForm.foundationName': 'Foundation Name',
  'pinForm.galleryMission': 'Gallery Mission',
  'pinForm.heritageType': 'Heritage Type',
  'pinForm.historicalDescription': 'Historical Description',
  'pinForm.historicalPeriod': 'Historical Period',
  'pinForm.officialWebsite': 'Official Website',
  'pinForm.sourceReferences': 'Source References',
  'pinForm.verificationStatus': 'Verification Status',

  // ── Event Edit/Create Extras ─────────────────────
  'eventForm.eventTitle': 'Event Title',
  'eventForm.eventType': 'Event Type',
  'eventForm.recurrence': 'Recurrence',
  'eventForm.oneTime': 'One-time',
  'eventForm.daily': 'Daily',
  'eventForm.weekly': 'Weekly',
  'eventForm.monthly': 'Monthly',
  'eventForm.linkedVenue': 'Linked Venue (Pin)',
  'eventForm.ticketPrice': 'Ticket Price',
  'eventForm.deleteConfirm': 'Delete this event? This cannot be undone.',
  'eventForm.saved': 'Saved!',
  'eventForm.deleting': 'Deleting...',
  'eventForm.createEvent': 'Create Event',
  'eventForm.venueName': 'Venue Name',

  // ── Profile Edit/Create Extras ───────────────────
  'profileForm.mediums': 'Mediums',
  'profileForm.instagram': 'Instagram',
  'profileForm.facebook': 'Facebook',

  // ── Artwork Edit/Create Extras ───────────────────
  'artworkForm.artistName': 'Artist Name',
  'artworkForm.artworkUid': 'Artwork ID',
  'artworkForm.createArtwork': 'Create Artwork',
  'profileForm.createProfile': 'Create Profile',
  'profileForm.displayName': 'Display Name',
  'profileForm.profileType': 'Profile Type',
  'routeForm.createRoute': 'Create Route',
  'routeForm.deleteRoute': 'Delete Route',

  // ── Route Create Extras ──────────────────────────
  'routeForm.difficulty': 'Difficulty',
  'routeForm.easy': 'Easy',
  'routeForm.moderate': 'Moderate',
  'routeForm.challenging': 'Challenging',
  'routeForm.region': 'Region',

  // ── Event Detail ─────────────────────────────────
  'eventDetail.artworks': 'Artworks',
  'eventDetail.tags': 'Tags',
  'eventDetail.linkedPins': 'Places in this event',
  'eventDetail.joinEvent': 'Join this event',
  'eventDetail.joinEventHint': 'Attach your places and artworks so they appear when someone explores this event on the map. You can attach the same item to multiple events.',
  'eventDetail.yourPins': 'Your places',
  'eventDetail.yourArtworks': 'Your artworks',
  'eventDetail.clickToShowArtists': 'Click to show participating artists',
  'eventDetail.clickToShowPlaces': 'Click to show places',
  'eventDetail.clickToHide': 'Click to collapse',

  // ── Months (abbreviated) ─────────────────────────
  'monthShort.0': 'Jan', 'monthShort.1': 'Feb', 'monthShort.2': 'Mar',
  'monthShort.3': 'Apr', 'monthShort.4': 'May', 'monthShort.5': 'Jun',
  'monthShort.6': 'Jul', 'monthShort.7': 'Aug', 'monthShort.8': 'Sep',
  'monthShort.9': 'Oct', 'monthShort.10': 'Nov', 'monthShort.11': 'Dec',

  // ── Pin Detail Extras ────────────────────────────
  'pinDetail.claimPin': 'Claim this location',
  'pinDetail.claimSupport': 'Manage and edit this listing — take control of this location and keep it up to date.',
  'pinDetail.claimPlaceholder': 'Why are you claiming this location? (e.g., I am the gallery owner)',
  'pinDetail.claimReleaseConfirm': 'Release this location? You will lose ownership and it will become unclaimed.',


  // ── Common Extras ────────────────────────────────
  'common.saved': 'Saved',
  'common.submitting': 'Submitting...',
  'common.lensQr': 'Lens QR',
  'common.editPin': 'Edit Pin',
  'common.manage': 'Manage',
  'common.newArticle': 'New Article',
  'common.createRoute': 'Create Route',
  'common.createEvent': 'Create Event',
  'common.createProfile': 'Create Profile',
  'common.all': 'All',
  'common.artist': 'Artist',
  'common.collective': 'Collective',
  'common.curator': 'Curator',
  'common.kmAway': 'km away',
  'common.showOnMap': 'Show on Map',
  'common.loadingOf': 'Loading...',
  'common.of': 'of',
  'common.away': 'away',
  'common.nearby': 'nearby',
  'share.share': 'Share',
  'share.sendToFriend': 'Send to a friend',
  'share.whatsapp': 'WhatsApp',
  'share.copyLink': 'Copy link',
  'share.copied': 'Link copied!',
  'share.email': 'Email',
  'share.viaArtRouting': 'on ArtRouting',
  'discover.unclaimed': 'Unclaimed',
  'nav.messages': 'Messages',
  // Messaging — mute, block, and the user's own on/off switch
  'messaging.fieldTier': 'Tier',
  'messaging.fieldAmplifier': 'Amplifier',
  'curatorType.creator': 'Creator',
  'curatorType.manager': 'Manager',
  'curatorType.agent': 'Agent',
  'messaging.fieldRole': 'Role',
  'messaging.fieldCountry': 'Country',
  'messaging.fieldLocation': 'Location',
  'messaging.removeMember': 'Remove',
  'messaging.removeMemberConfirm': 'Remove {name} from this group? They lose access to it. Messages they already sent stay in the conversation.',
  'messaging.errCannotRemoveOwner': 'The person who created the group cannot be removed — delete the group instead.',
  'messaging.errNotAMember': 'That person is not in this group.',
  'messaging.groupMembers': 'Group members',
  'messaging.groupOwner': 'Owner',
  'messaging.deleteGroup': 'Delete group',
  'messaging.deleteGroupConfirm': 'Delete this group? It disappears for every member, along with all its messages. This cannot be undone.',
  'messaging.errNotGroupOwner': 'Only the person who created this group can delete it.',
  'messaging.errNotAGroup': 'This conversation is not a group.',
  'messaging.errConversationNotFound': 'That conversation no longer exists.',
  'messaging.conversationMenu': 'Conversation options',
  'messaging.mute': 'Mute conversation',
  'messaging.unmute': 'Unmute conversation',
  'messaging.muted': 'Muted',
  'messaging.block': 'Block this person',
  'messaging.unblock': 'Unblock',
  'messaging.blocked': 'Blocked',
  'messaging.blockConfirm': 'Block this person? Neither of you will be able to send messages until you unblock them. They are not told.',
  'messaging.blockedNotice': 'You blocked this person. Unblock to write again.',
  'messaging.blockedPeople': 'Blocked people',
  'messaging.noBlocked': 'You have not blocked anyone.',
  'messaging.privacy': 'Privacy',
  'messaging.turnOff': 'Turn messaging off',
  'messaging.turnOn': 'Turn messaging on',
  'messaging.offTitle': 'Messaging is off',
  'messaging.offBody': 'Your messaging is switched off. Nobody can start a conversation with you or add you to a group, and Messages stays out of your menu.',
  'messaging.offConfirm': 'Turn messaging off? Nobody will be able to message you or add you to a group, and Messages disappears from your menu until you turn it back on.',
  'messaging.errBlockedByYou': 'You blocked this person. Unblock them to send a message.',
  'messaging.errBlockedByThem': 'This person is not accepting messages.',
  'messaging.errRecipientUnavailable': 'This person is not accepting messages.',
  'messaging.errMessagingOff': 'Your messaging is switched off. Turn it on to send messages.',
  'messaging.errNoReachableMembers': 'None of the people you picked are accepting messages right now.',
  'messaging.errSendFailed': 'Failed to send',
  'messaging.errFailed': 'That did not work',
  'account.section.messaging': 'Messaging',
  'account.section.messagingDesc': 'Decide whether other people on ArtRouting can write to you.',
  'account.messaging.toggle': 'Allow people to message me',
  'account.messaging.hintOn': 'Messages appears in your menu and people can start a conversation with you or add you to a group.',
  'account.messaging.hintOff': 'Messaging is off — you are hidden from people search and group invitations, and Messages is not in your menu.',
  'account.messaging.saved': 'Messaging setting saved',
  'common.close': 'Close',
  'messaging.title': 'Messages',
  'messaging.newMessage': 'New message',
  'messaging.searchRecipient': 'Search people…',
  'messaging.noConversations': 'No conversations yet',
  'messaging.send': 'Send',
  'messaging.typeMessage': 'Type a message…',
  'messaging.notAvailable': 'Messaging isn’t available for your account yet.',
  'messaging.sent': 'Sent',
  'messaging.delivered': 'Delivered',
  'messaging.read': 'Read',
  'messaging.markUnread': 'Mark as unread',
  'messaging.markRead': 'Mark as read',
  'messaging.markUnreadHint': 'Keep this in your inbox as an unread reminder (the sender still sees it as read).',
  'messaging.markReadHint': 'Clear the unread reminder.',
  'messaging.selectConversation': 'Select a conversation to start chatting',
  'messaging.changeAvatar': 'Change your photo',
  'messaging.uploadPhoto': 'Upload a photo',
  'messaging.useProfilePhoto': 'Use profile photo',
  'messaging.removePhoto': 'Remove photo',
  'messaging.direct': 'Direct',
  'messaging.group': 'Group',
  'messaging.groupName': 'Group name',
  'messaging.createGroup': 'Create group',
  'messaging.members': 'members',
  'messaging.myStatus': 'Your status',
  'messaging.statusAvailable': 'Open to chat',
  'messaging.statusBusy': 'Not open to chat',
  'messaging.statusOffline': 'Offline',
  'messaging.searchMessages': 'Search messages',
  'messaging.searchHint': 'Type to search your messages',
  'messaging.noResults': 'No messages found',
  'messaging.you': 'You',
  'messaging.notesToSelf': 'Notes to self — jot down anything you want to remember',
  'nav.aboutUs': 'About Us',
  'common.remaining': 'remaining',
  'common.results': 'results',
  'common.result': 'result',
  'common.loadMore': 'Load More',
  'common.myArtworks': 'My Artworks',
  'common.allDifficulties': 'All Difficulties',
  'common.stops': 'stops',
  'common.days': 'days',
  'common.routes': 'routes',
  'common.verified': 'Verified',
  'common.locating': 'Locating...',
  'common.nearMeOn': 'Near Me ON',
  'common.nearMe': 'Near Me',
  'common.pinTypes': 'Pin Types',
  'common.loadingPins': 'Loading pins...',
  'common.searchPlaceholder': 'Search city or town...',
  'common.searching': 'Searching',
  'common.clearAll': 'Clear all',
  'common.filters': 'Filters',
  'common.pinType': 'Pin Type',
  'common.routeType': 'Route Type',
  'common.profileType': 'Profile Type',
  'common.articleCategory': 'Article Category',
  'common.eventType': 'Event Type',
  'common.sortEvents': 'Sort Events',
  'common.discoverType': 'Discover Type',
  'common.country': 'Country',
  'common.allCountries': 'All Countries',
  'filter.what': 'What',
  'filter.where': 'Where',
  'filter.when': 'When',
  'filter.cityTown': 'City / Town',
  'filter.searchCityTown': 'Search city or town...',
  'filter.dateRange': 'Date Range',
  'filter.from': 'From',
  'filter.to': 'To',
  'common.manageArticles': 'Manage Articles',
  'common.manageArticlesDesc': 'Create, edit, and manage editorial content',
  'common.publicView': 'Public View',
  'common.noArticlesYet': 'No articles yet. Create your first one!',
  'common.createArticle': 'Create Article',
  'common.noArticlesMatch': 'No articles match your search',
  'common.searchArticles': 'Search articles...',
  'common.acceptsStudioVisits': 'Accepts studio visits',
  'common.artisticPhilosophy': 'Artistic Philosophy',
  'common.contactLinks': 'Contact & Links',
  'common.artworksByArtist': 'Artworks by this Artist',
  'common.getDirections': 'Get Directions',
  'common.submitClaim': 'Submit Claim',
  'common.claimPending': 'Your claim is pending admin review.',
  'common.claimDescription': 'Is this your artist profile? Submit a claim to become the verified owner and manage your presence.',
  'common.claimPlaceholder': 'Why are you claiming this profile? (optional)',
  'common.routesWillAppear': 'Cultural routes will appear here once they are created.',
  'common.loadingMoreRoutes': 'Loading more routes...',

  // ── Pin Types ───────────────────────────────────
  'pinType.gallery': 'Gallery',
  'pinType.museum': 'Museum',
  'pinType.art_centre': 'Art Centre',
  'pinType.studio': 'Studio',
  'pinType.venue': 'Venue',
  'pinType.heritage': 'Heritage',
  'pinType.supplier': 'Supplier',
  'pinType.education': 'Education',
  'pinType.residency': 'Residency',
  'pinType.public_art': 'Public Art',
  'pinType.cultural_site': 'Cultural Site',
  'pinType.collection': 'Collection',
  'pinType.artist': 'Artist',
  'pinType.artwork': 'Artwork',

  // ── Profile Section Titles ─────────────────────
  'profile.about': 'About',
  'profile.mediums': 'Mediums',
  'profile.tags': 'Tags',
  'profile.artisticStyle': 'Artistic Style',
  'profile.studioHours': 'Studio Hours',
  'profile.viewProfile': 'View Artist Profile',
  'profile.events': 'Events',
  'profile.eventsDesc': 'Link your pins to upcoming events so they appear on the map when that event is active.',
  'profile.eventsNoPins': 'You have no claimed pins yet. Create or claim a pin first.',
  'profile.eventsNoEvents': 'No upcoming events found.',
  'profile.eventsJoin': 'Join',
  'profile.eventsLeave': 'Leave',
  'profile.eventsJoined': 'Joined',
  'profile.eventsLoading': 'Loading events…',

  // ── Profile Form ──────────────────────────────────
  'profileForm.artisticPhilosophy': 'Artistic Philosophy',
  'profileForm.contactEmail': 'Contact Email',
  'profileForm.coverImageUrl': 'Cover Image URL',
  'profileForm.profileImageUrl': 'Profile Image URL',
  'profileForm.studioVisits': 'I accept studio visits',
  'profileForm.studioInfo': 'Studio Information',
  'profileForm.visibilityStatus': 'Visibility Status',
  'profileForm.importAuto': 'Import your profile automatically',
  'profileForm.hideFromMap': 'Hide my profile from the map',
  'profileForm.hideFromMapHint': 'My profile stays searchable and reachable through host galleries / studios, but my own dot is not drawn on the map.',
  'profileForm.hostPins.title': 'Linked galleries & studios',
  'profileForm.hostPins.desc': 'Link your profile to galleries or studios that host your work. Visitors browsing those pins will see you listed under "Artists hosted here" — useful when your own pin is hidden.',
  'profileForm.hostPins.searchLabel': 'Find a gallery or studio',
  'profileForm.hostPins.searchPlaceholder': 'Type 2+ characters to search…',
  'profileForm.hostPins.roleLabel': 'Relationship',
  'profileForm.hostPins.role.represented_by': 'Represented by',
  'profileForm.hostPins.role.studio_at': 'Studio at',
  'profileForm.hostPins.role.exhibits_at': 'Exhibits at',
  'profileForm.hostPins.role.collective_member': 'Collective member',
  'profileForm.hostPins.verb.represented_by': 'is represented by',
  'profileForm.hostPins.verb.studio_at': 'has a studio at',
  'profileForm.hostPins.verb.exhibits_at': 'exhibits at',
  'profileForm.hostPins.verb.collective_member': 'is part of',
  'profileForm.hostPins.youLabel': 'You',
  'profileForm.hostPins.remove': 'Remove',
  'profileForm.hostPins.alreadyLinked': 'Already linked',

  // ── Pin Form ──────────────────────────────────────
  'pinForm.clickMap': 'Click the map to set coordinates',

  // ── Event Form (additional) ───────────────────────
  'eventForm.culturalSignificance': 'Cultural Significance',
  'eventForm.organizerEmail': 'Organizer Email',
  'eventForm.organizerName': 'Organizer Name',
  'eventForm.participatingArtists': 'Participating Artists',
  'eventForm.artistsHint': 'Search artists, galleries or venues, or type a name and press Enter',
  'eventForm.searchArtists': 'Search or type a name…',
  'eventForm.addCustomArtist': 'Add',
  'eventForm.noArtistsLinked': 'No participants added yet',
  'eventForm.linkedPlaces': 'Places in this event',
  'eventForm.searchPins': 'Search pins to add…',
  'eventForm.noLinkedPlaces': 'No places linked yet. Search above to add studios, galleries, venues…',
  'eventForm.ticketUrl': 'Ticket URL',

  // ── Route Form (additional) ───────────────────────
  'routeForm.bestSeason': 'Best Season',
  'routeForm.coverImage': 'Cover image for route cards and detail page',
  'routeForm.estimatedDuration': 'Estimated Duration',
  'routeForm.imageUrl': 'Image URL',
  'routeForm.slug': 'Slug',
  'routeForm.culturalSignificance': 'Cultural Significance',

  // ── Provenance ────────────────────────────────────
  'provenance.date': 'Date',
  'provenance.eventType': 'Event Type',
  'provenance.location': 'Location',
  'provenance.latest': 'LATEST',

  // ── Submission (additional) ───────────────────────
  'submission.imageUrl': 'Image URL',
  'submission.photoLink': 'Link to a photo of the venue or event',
  'submission.moderatorNotes': 'Notes for Moderator',

  // ── Contact ─────────────────────────────────────────
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Have a question, suggestion, or want to collaborate? Send us a message and we\'ll get back to you.',
  'contact.directEmail': 'Or email us directly',
  'contact.yourDetails': 'Your Details',
  'contact.name': 'Name',
  'contact.namePlaceholder': 'Your full name',
  'contact.email': 'Email',
  'contact.emailPlaceholder': 'your@email.com',
  'contact.yourMessage': 'Your Message',
  'contact.message': 'Message',
  'contact.messagePlaceholder': 'Tell us what\'s on your mind...',
  'contact.send': 'Send Message',
  'contact.sending': 'Sending...',
  'contact.sendFailed': 'Failed to send message. Please try again.',
  'contact.allRequired': 'Please fill in all fields.',
  'contact.thankYou': 'Message Sent!',
  'contact.successMessage': 'Thank you for reaching out. We\'ll get back to you at the email address you provided.',
  'contact.sendAnother': 'Send Another Message',
  'footer.contact': 'Contact',

  // ── Common (additional) ───────────────────────────
  'common.login': 'Log in',

  // ── Import Wizard ─────────────────────────────────
  'importWizard.title': 'Import Profile from URL',
  'importWizard.subtitle': 'Build your artist profile from your web presence',
  'importWizard.introTitle': 'Welcome to Profile Import',
  'importWizard.introDesc': 'This wizard will help you build your artist profile from your existing web presence. Have these ready before you start:',
  'importWizard.checklist': 'What you\'ll need',
  'importWizard.checkUrls': 'Your website, portfolio, or social media URLs',
  'importWizard.checkImages': 'Profile photo and artwork images (extracted automatically)',
  'importWizard.checkBio': 'Your bio or artist statement (extracted or you can write one)',
  'importWizard.checkLocation': 'Your studio/gallery city and country',
  'importWizard.checkSocial': 'Social media links (Instagram, Facebook, etc.)',
  'importWizard.howItWorks': 'How it works',
  'importWizard.step1Desc': 'Paste your website & social URLs — we scan them with AI',
  'importWizard.step2Desc': 'Review extracted data — select artworks, edit text',
  'importWizard.step3Desc': 'Fine-tune your profile — name, bio, mediums',
  'importWizard.step4Desc': 'Add location & social links',
  'importWizard.step5Desc': 'Review and save — everything in one go',
  'importWizard.importMode': 'Import Mode',
  'importWizard.importForMyself': 'Import for Myself',
  'importWizard.importForMyselfDesc': 'Add artworks to your profile & studio',
  'importWizard.importNewArtist': 'Import New Artist',
  'importWizard.importNewArtistDesc': 'Create a standalone profile for another artist',
  'importWizard.getStarted': 'Get Started',
  'importWizard.urlTitle': 'Add Your URLs',
  'importWizard.urlDesc': 'Paste your website, portfolio, or social media URLs. We\'ll scan each one with AI to extract your info and artworks.',
  'importWizard.urlsLabel': 'Website or Social Media URLs',
  'importWizard.singleInput': 'Single input',
  'importWizard.pasteMultiple': 'Paste multiple',
  'importWizard.bulkPlaceholder': 'Paste multiple URLs here, one per line',
  'importWizard.addUrls': 'Add',
  'importWizard.addAnotherUrl': 'Add another URL',
  'importWizard.extracting': 'Extracting',
  'importWizard.extractPreview': 'Extract & Preview',
  'importWizard.orManual': 'or create manually',
  'importWizard.extractingInfo': 'Each URL takes up to 30 seconds. We\'re scanning each site with AI to extract artist information, bios, and artworks.',
  'importWizard.tipsTitle': 'Tips for best results',
  'importWizard.tip1': 'Add multiple URLs to build a complete profile — website, Instagram, Facebook, etc.',
  'importWizard.tip2': 'Your portfolio or "About" page gives the best bio and artwork extraction',
  'importWizard.tip3': 'Instagram and Facebook artist pages are supported',
  'importWizard.tip4': 'Each URL enriches your profile — artworks from all sources are combined',
  'importWizard.tip5': 'You\'ll see a full preview before anything is saved',
  'importWizard.reviewTitle': 'Review Extracted Data',
  'importWizard.reviewDesc': 'We found the following from your URLs. Select the artworks you want to keep and edit any text. You can refine details in the next steps.',
  'importWizard.duplicateFound': 'Similar profiles found',
  'importWizard.duplicateDesc': 'We found profiles with a similar name. You can merge into an existing one or create new.',
  'importWizard.exactMatch': 'EXACT MATCH',
  'importWizard.mergeInto': 'Merge',
  'importWizard.cancelMerge': 'Cancel merge — create new instead',
  'importWizard.noName': 'No name extracted',
  'importWizard.artworksFound': 'Artworks Found',
  'importWizard.selected': 'selected',
  'importWizard.deselectAll': 'Deselect All',
  'importWizard.selectAll': 'Select All',
  'importWizard.artworkTitle': 'Title',
  'importWizard.medium': 'Medium',
  'importWizard.year': 'Year',
  'importWizard.dimensions': 'Dimensions',
  'importWizard.noArtworks': 'No artworks were found on the crawled pages. You can add artworks manually after saving.',
  'importWizard.nextProfile': 'Next: Edit Profile',
  'importWizard.profileTitle': 'Profile Details',
  'importWizard.profileDesc': 'Edit your profile information. Fields are pre-filled from the extracted data.',
  'importWizard.namePlaceholder': 'Artist or gallery name',
  'importWizard.bioPlaceholder': 'Tell the world about your artistic practice...',
  'importWizard.stylePlaceholder': 'e.g. Contemporary, Abstract, Realism',
  'importWizard.nextLocation': 'Next: Location & Links',
  'importWizard.locationTitle': 'Location & Links',
  'importWizard.locationDesc': 'Add your location so people can find you on the map, and your web presence.',
  'importWizard.cityPlaceholder': 'e.g. Amsterdam',
  'importWizard.countryPlaceholder': 'e.g. Netherlands',
  'importWizard.nextReview': 'Next: Review & Save',
  'importWizard.reviewTitle2': 'Review & Save',
  'importWizard.reviewDesc2': 'Review everything before saving. Make sure all details are correct.',
  'importWizard.duplicateWarning': 'Duplicate Warning',
  'importWizard.duplicateWarningDesc': 'Profiles with similar names already exist. Consider merging to avoid duplicates.',
  'importWizard.mergingInto': 'Merging into existing profile',
  'importWizard.addingToYour': 'Adding to your profile',
  'importWizard.creatingNew': 'Creating new standalone profile',
  'importWizard.noLocation': 'No location set',
  'importWizard.hasWebsite': 'Website',
  'importWizard.mediums': 'mediums',
  'importWizard.socialLinks': 'social links',
  'importWizard.artworksToImport': 'artwork(s) to import',
  'importWizard.addToProfile': 'Add to My Profile',
  'importWizard.mergeAndSave': 'Merge & Save',
  'importWizard.saveProfile': 'Save Profile',
  'importWizard.profileUpdated': 'Profile Updated!',
  'importWizard.profileCreated': 'Profile Created!',
  'importWizard.artworksSaved': 'artwork(s) saved',
  'importWizard.reviewEdit': 'Review & Edit Profile',
  'importWizard.viewProfile': 'View Profile',
  'importWizard.importAnother': 'Import another profile',
  'importWizard.startOver': 'Start over',
  'importWizard.stepIntro': 'Start',
  'importWizard.stepUrls': 'URLs',
  'importWizard.stepReview': 'Review',
  'importWizard.stepProfile': 'Profile',
  'importWizard.stepLocation': 'Location',
  'importWizard.stepSave': 'Save',
  'importWizard.addressPlaceholder': 'e.g. 12 Main Street, Calitzdorp, 6660',
  'importWizard.addressHint': 'Street address, suburb, postal code — for precise map pin placement.',
  'importWizard.pinWillCreate': 'Map pin will be created',
  'importWizard.noPinWarning': 'No map pin without a location — enter at least your city.',
  'importWizard.doNotNavigate': 'Please wait — do not close or navigate away from this page.',
  'profileForm.address': 'Full Address',

  // ── Profile Wizard (Guided Setup) ─────────────────
  'wizard.title': 'Create Your Artist Profile',
  'wizard.introDesc': 'This wizard will guide you through setting up your profile on ArtRouting in 5 simple steps. Before you start, here\'s what you\'ll need. Don\'t worry — everything is optional and your progress is saved automatically, so you can leave and come back any time.',
  'wizard.step1Title': 'Your name and a profile photo',
  'wizard.step2Title': 'A short bio about your art',
  'wizard.step3Title': 'Your city and country',
  'wizard.step4Title': 'Your website and social media links',
  'wizard.step5Title': 'Review and publish',
  'wizard.haveWebsite': 'Have a website or Instagram?',
  'wizard.haveWebsiteDesc': 'You can paste a link in Step 1 and we\'ll automatically fill in your name, bio, photo, and social links using AI. It takes about 10 seconds.',
  'wizard.progressSaved': 'Your progress is saved automatically',
  'wizard.progressSavedDesc': 'You can close this page and come back later — you\'ll pick up right where you left off.',
  'wizard.step1of5': 'Step 1 of 5',
  'wizard.step2of5': 'Step 2 of 5',
  'wizard.step3of5': 'Step 3 of 5',
  'wizard.step4of5': 'Step 4 of 5',
  'wizard.step5of5': 'Step 5 of 5',
  'wizard.letsGetStarted': 'Let\'s Get Started',
  'wizard.step1Desc': 'First, the basics. Tell us who you are so visitors can find and recognise you on ArtRouting.',
  'wizard.quickImport': 'Quick Import — paste your URLs and we\'ll fill everything in for you',
  'wizard.yourName': 'Your Name',
  'wizard.whatDescribes': 'What best describes you?',
  'wizard.profilePhoto': 'Profile Photo',
  'wizard.tellStory': 'Tell Your Story',
  'wizard.step2Desc': 'Share what makes your art unique. This helps visitors connect with your work.',
  'wizard.aboutYou': 'About You',
  'wizard.artStyle': 'Your Art Style',
  'wizard.mediums': 'Mediums You Work With',
  'wizard.tapToSelect': 'Tap to select. You can also type your own below.',
  'wizard.whereAreYou': 'Where Are You Based?',
  'wizard.step3Desc': 'This puts you on the ArtRouting map so people nearby can discover you. Enter your address and we\'ll find the coordinates automatically.',
  'wizard.fullAddress': 'Full Address',
  'wizard.cityTown': 'City / Town',
  'wizard.country': 'Country',
  'wizard.coverImage': 'Cover Image',
  'wizard.pinWillCreate': 'Map pin will be created',
  'wizard.noPinWarning': 'No map pin without a location',
  'wizard.verifyLocation': 'Verify Location on Map',
  'wizard.connectWorld': 'Connect With the World',
  'wizard.step4Desc': 'Add your links so visitors can follow your work. Just paste the full URL or your username. Everything is optional.',
  'wizard.websitePortfolio': 'Your Website or Portfolio',
  'wizard.socialMedia': 'Social Media',
  'wizard.contactEmail': 'Contact Email',
  'wizard.reviewPublish': 'Review & Publish',
  'wizard.step5Desc': 'Here\'s how your profile looks. Go back to make changes, or save now and edit more later.',
  'wizard.saveAsDraft': 'Save as Draft',
  'wizard.publishProfile': 'Publish Profile',
  'wizard.continue': 'Continue',
  'wizard.resumeWhereLeft': 'Resume where I left off',
  'wizard.startFresh': 'Start Over',
  'wizard.letMeStart': 'Let\'s Go!',
  'wizard.clickToExpand': 'expand',
  'wizard.backToProfile': 'Back to My Profile',

  // ── i18n sweep 2026-04-21 (every English word gets a DE pair) ──
  'account.title': 'Account Settings',
  'account.subtitle': 'Your personal account settings. These are separate from your Artist Profile.',
  'account.section.info': 'Account Information',
  'account.section.infoDesc': 'Your login details and account type. To change your password, use the Change Password option.',
  'account.label.email': 'Email',
  'account.label.displayName': 'Display Name',
  'account.label.tier': 'Tier',
  'account.tier.free': 'Free',
  'account.tier.tier1': 'Profile',
  'account.tier.tier2': 'Pro',
  'account.section.role': 'Your Role',
  'account.section.roleDesc': 'Switch between Explorer, Artist, or Gallery at any time — no re-registration needed. Changing your role updates what you can do on ArtRouting (explore, showcase work, represent a gallery).',
  'account.role.explorer': 'Explorer',
  'account.role.explorerDesc': 'I want to discover art',
  'account.role.artist': 'Artist',
  'account.role.artistDesc': 'I want to showcase my art',
  'account.role.gallery': 'Art Venue',
  'account.role.galleryDesc': 'I present or exhibit art at a physical place — gallery, museum, fair, pop-up',
  'account.role.updated': 'Role updated!',
  'account.role.failed': 'Failed to change role. Please try again.',
  'account.section.nearme': 'Near Me Location',
  'account.section.nearmeDesc': 'Set your town or city for the "Near Me" feature on the map. When you click Near Me, it will center on this location instead of using your device\'s GPS. Leave blank to use GPS location detection.',
  'account.nearme.label': 'Town / City for Near Me',
  'account.nearme.placeholder': 'e.g. Berlin, Rostock, Amsterdam...',
  'account.nearme.hint': 'Enter your town or city name. When you use "Near Me" on the map, it will search around this location. If left empty, Near Me will ask your browser for GPS permission.',
  'account.nearme.save': 'Save Near Me Location',
  'account.nearme.saving': 'Saving...',
  'account.nearme.saved': 'Saved!',
  'account.nearme.failed': 'Failed to save. Please try again.',
  'account.section.privacy': 'Map & Address Privacy',
  'account.section.privacyDesc': 'Control whether your location pin and physical address are shown publicly on the map.',
  'account.privacy.toggle': 'Show my pin and address on the map',
  'account.privacy.hintOn': 'Your pin appears on the map and your address is visible so people can come and visit you.',
  'account.privacy.hintOff': 'Your pin is removed from the map and your address is hidden everywhere. Your artworks, articles and profile stay visible.',
  'account.privacy.saved': 'Saved!',
  'account.privacy.failed': 'Failed to save. Please try again.',
  'account.loginRequired': 'Please log in to view account settings.',
  'account.section.artistProfile': 'Artist Profile',
  'account.section.artistProfileDesc': 'Your Artist Profile is your public presence on ArtRouting — it shows your bio, artworks, location on the map, and more. It\'s separate from your account settings above.',
  'account.goToProfile': 'Go to My Artist Profile →',
  'account.section.curator': 'Curator',
  'account.section.curatorDesc': 'As an {tier} user you can act as a Curator — a gallery, agent or manager who creates and manages profiles, artworks and articles on behalf of artists. Choose whether you want to act as a Curator and what type below.',
  'account.curator.toggle': 'I want to act as a Curator',
  'account.curator.typeLabel': 'Curator Type',
  'account.curator.type.creator': 'Creator — I create profiles and content from scratch',
  'account.curator.type.manager': 'Manager — I manage existing artist data and presence',
  'account.curator.type.agent': 'Agent — I represent artists as their professional agent',
  'account.curator.typeHint': 'Your selected type is shown next to your name on the artists you curate.',
  'account.curator.saved': 'Curator settings saved.',
  'account.curator.failed': 'Failed to save curator settings.',

  'profileDetail.curateThisArtist': 'Curate this Artist',
  'profileDetail.curating': 'You are curating this artist',
  'profileDetail.curatingDesc': 'This artist appears under your My Artists menu. Click below to stop curating.',
  'profileDetail.curateDesc': 'Add this artist to your My Artists. As a {type} you will be able to manage their profile, artworks and articles from one place.',
  'profileDetail.curateButton': 'Curate this Artist',
  'profileDetail.stopCurating': 'Stop Curating',
  'profileDetail.curateFailed': 'Failed to update curator status.',
  'profileDetail.curatedBy': 'Curated by',
  'profileDetail.artistsIWorkWith': 'Artists I Work With',
  'profileDetail.noArtistsYet': 'Not yet curating any artists.',
  'profileDetail.curatedEvents': 'Curated Events / Projects',
  'profileDetail.noEventsYet': 'No events organized yet.',

  'myArtists.title': 'My Artists',
  'myArtists.subtitle': 'Artists you are curating. Click an artist to see their full profile, artworks and articles in one workspace.',
  'myArtists.empty': 'You are not curating any artists yet.',
  'myArtists.emptyHint': 'Open an artist profile and click "Curate this Artist" to add them here.',
  'myArtists.notCurator': 'Curator access required',
  'myArtists.notCuratorDesc': 'My Artists is only available to {tier} users who have enabled Curator mode in their account settings.',
  'myArtists.goToAccount': 'Go to Account Settings',
  'myArtists.back': 'Back to My Artists',
  'myArtists.openProfile': 'Open public profile',
  'myArtists.editProfile': 'Edit profile',
  'myArtists.bio': 'Bio',
  'myArtists.artworks': 'Artworks',
  'myArtists.articles': 'Articles',
  'myArtists.noArtworks': 'No artworks yet.',
  'myArtists.noArticles': 'No articles yet.',
  'myArtists.notFound': 'Artist not found or no longer curated.',
  'myArtists.detailLoadFailed': 'Failed to load artist details.',
  'myArtists.addArtist': 'Add Artist',
  'myArtists.cancelAdd': 'Cancel',
  'myArtists.searchLabel': 'Search for an artist by name',
  'myArtists.searchPlaceholder': 'Type at least 2 characters...',
  'myArtists.noSearchResults': 'No matching artists found.',
  'myArtists.addFailed': 'Failed to add artist.',

  'myArticles.title': 'My Articles',
  'myArticles.subtitle': 'Articles you have written. Member articles are reviewed by the ArtRadar editors before they are published.',
  'myArticles.createNew': 'Submit a new article',
  'myArticles.createFirst': 'Submit your first article',
  'myArticles.empty': 'You have no articles yet.',
  'myArticles.emptyFilter': 'No articles match this filter.',
  'myArticles.deleteConfirm': 'Delete "{title}"? This cannot be undone.',
  'myArticles.deleteFailed': 'Failed to delete article.',
  'myArticles.filter.all': 'All',
  'myArticles.filter.draft': 'Drafts',
  'myArticles.filter.published': 'Published',

  'myCurators.title': 'My Curators',
  'myCurators.subtitle': 'Curators (galleries, agents and managers) who curate any of your profiles. Add a curator below to let them help manage your artworks and articles.',
  'myCurators.empty': 'No claimed profiles yet.',
  'myCurators.emptyHint': 'When a curator adds you, they appear here grouped by which of your profiles they curate.',
  'myCurators.emptyClaimHint': 'Claim or create a profile first — then you can add curators to it.',
  'myCurators.findProfile': 'Find a Profile to Claim',
  'myCurators.since': 'Since',
  'myCurators.addCurator': 'Add Curator',
  'myCurators.cancelAdd': 'Cancel',
  'myCurators.searchLabel': 'Search for a curator by name or email',
  'myCurators.searchPlaceholder': 'Type at least 2 characters...',
  'myCurators.noResults': 'No eligible curators found. Curators must be {tier} users with curator mode enabled.',
  'myCurators.noCuratorsForProfile': 'No curators on this profile yet. Click Add Curator to invite one.',
  'myCurators.remove': 'Remove',
  'myCurators.removeConfirm': 'Remove this curator? They will lose access to manage this profile.',
  'myCurators.removeFailed': 'Failed to remove curator.',
  'myCurators.addFailed': 'Failed to add curator.',

  'common.loginRequired': 'Please log in to continue.',

  'map.geolocationUnsupported': 'Geolocation is not supported by your browser.',
  'map.locationDenied': 'Location access denied. Please enable location permissions in your browser settings.',
  'map.locationFailed': 'Could not determine your location. Please try again.',
  'map.failedLoadPins': 'Failed to load pins. Please try refreshing.',
  'map.backToHome': 'Back to Home',
  'map.addNewPin': 'Add new pin',
  'map.findMyLocation': 'Find my location',
  'map.collapseLegend': 'Collapse/Expand legend',
  'map.togglePins': 'Toggle {type} pins',
  'map.eventDetails': 'Details',
  'map.eventsMatching': 'Events matching',
  'map.exitEventMode': 'Exit',
  'map.eventCount.one': '{n} event',
  'map.eventCount.other': '{n} events',
  'map.eventFallbackTitle': 'Event',

  'pinDetail.home': 'Home',
  'pinDetail.mission': 'Mission',
  'pinDetail.appointmentRequired': 'Appointment required',
  'pinDetail.admission': 'Admission',
  'pinDetail.culturalContext': 'Cultural Context',
  'pinDetail.culturalSignificance': 'Cultural Significance',
  'pinDetail.historicalNotes': 'Historical Notes',
  'pinDetail.bestTimeToVisit': 'Best Time to Visit',
  'pinDetail.heritageInfo': 'Heritage Information',
  'pinDetail.heritageType': 'Heritage Type',
  'pinDetail.associatedArtist': 'Associated Artist',
  'pinDetail.availableIn': 'Available in',
  'pinDetail.tags': 'Tags',
  'pinDetail.events': 'Events',
  'pinDetail.eventNow': 'Now',
  'pinDetail.eventUpcoming': 'Upcoming',
  'pinDetail.eventShowAll': 'Show all events',
  'pinDetail.pastExhibitionsHosted.one': 'Hosted {n} past exhibition',
  'pinDetail.pastExhibitionsHosted.other': 'Hosted {n} past exhibitions',
  'pinDetail.artistsHostedHere': 'Artists hosted here',
  'pinDetail.artworksByArtists': 'Artworks by these artists',
  'pinDetail.articlesByArtists': 'Articles',
  'pinDetail.curate': 'Curate',
  'pinDetail.curatingBadge': 'Curating',
  'pinDetail.ownerControls': 'Owner Controls',
  'pinDetail.makePrivate': 'Make Private',
  'pinDetail.makePublic': 'Make Public',
  'pinDetail.releaseClaim': 'Release Claim',
  'pinDetail.claimPrompt': 'to claim this location as your own.',
  'pinDetail.failedDelete': 'Failed to delete',
  'pinDetail.failedSubmitClaim': 'Failed to submit claim',
  'pinDetail.failedToggleVisibility': 'Failed to toggle visibility',
  'pinDetail.failedReleaseClaim': 'Failed to release claim',

  'pinForm.backToMap': 'Back to Map',
  'pinForm.backToPin': 'Back to Pin',
  'pinForm.createNewPin': 'Create New Pin',
  'pinForm.editPin': 'Edit Pin',
  'pinForm.section.basic': 'Basic Information',
  'pinForm.venueName': 'Venue name',
  'pinForm.describeVenue': 'Describe this venue...',
  'pinForm.section.location': 'Location',
  'pinForm.streetAddress': 'Street address',
  'pinForm.city': 'City',
  'pinForm.stateRegion': 'State / Region',
  'pinForm.country': 'Country',
  'pinForm.latExample': 'e.g. 54.0887',
  'pinForm.lngExample': 'e.g. 12.1407',
  'pinForm.section.image': 'Image',
  'pinForm.imageUrlLabel': 'Image URL',
  'pinForm.section.contact': 'Contact',
  'pinForm.httpsPlaceholder': 'https://...',
  'pinForm.phonePlaceholder': '+49 ...',
  'pinForm.emailPlaceholder': 'info@...',
  'pinForm.section.hoursTags': 'Hours & Tags',
  'pinForm.hoursPlaceholder': 'Mon-Fri: 10:00-18:00\nSat-Sun: 11:00-17:00',
  'pinForm.pricePlaceholder': 'Free / €10 / R50',
  'pinForm.priceHint': 'e.g. Free, €10 adults / €5 students',
  'pinForm.appointmentRequired': 'Appointment required',
  'pinForm.tagsPlaceholder': 'contemporary, sculpture, exhibitions',
  'pinForm.tagsHint': 'Comma-separated list of tags',
  'pinForm.languagesPlaceholder': 'EN, DE, FR',
  'pinForm.languagesHint': 'Comma-separated language codes',
  'pinForm.section.venueDetails': 'Venue Details',
  'pinForm.missionPlaceholder': 'Curatorial focus, mission statement...',
  'pinForm.missionHint': 'What is the venue\'s artistic focus or mission?',
  'pinForm.section.social': 'Social Media',
  'pinForm.usernamePlaceholder': 'username',
  'pinForm.pageNamePlaceholder': 'page-name',
  'pinForm.twitterXLabel': 'Twitter/X',
  'pinForm.section.additionalImages': 'Additional Images',
  'pinForm.addImageUrl': 'Add Image URL',
  'pinForm.additionalImagesHint': 'Up to 6 additional images (direct URLs)',
  'pinForm.maxImages': 'Maximum 6 additional images',
  'pinForm.section.cultural3W': '3W Cultural Context',
  'pinForm.culturalSignPlaceholder': 'Describe the cultural significance of this venue...',
  'pinForm.historicalNotesPlaceholder': 'Historical background and context...',
  'pinForm.bestTimePlaceholder': 'e.g. Spring (Sep-Nov), weekday mornings',
  'pinForm.section.heritageDetails': 'Heritage Details',
  'pinForm.section.mapVisibility': 'Map visibility',
  'pinForm.hideFromMap': 'Hide this pin from the map',
  'pinForm.hideFromMapHint': 'The pin still appears in search and direct links, but its dot is removed from the map.',
  'pinForm.hostedArtists.title': 'Hosted artists',
  'pinForm.hostedArtists.desc': 'Add artist profiles that show their work at this gallery or studio. They will appear under "Artists hosted here" on this pin.',
  'pinForm.hostedArtists.searchLabel': 'Find an artist profile',
  'pinForm.hostedArtists.searchPlaceholder': 'Type 2+ characters to search…',
  'pinForm.hostedArtists.remove': 'Remove',
  'pinForm.heritageTypeSelect': 'Select heritage type...',
  'pinForm.artistPlaceholder': 'e.g. Drew McRitchie',
  'pinForm.periodPlaceholder': 'e.g. 1920-1980',
  'pinForm.foundationPlaceholder': 'e.g. McRitchie Foundation',
  'pinForm.historicalDescPlaceholder': 'Describe the historical significance...',
  'pinForm.verificationVerified': 'Verified (Museum/Foundation confirmed)',
  'pinForm.verificationDocumented': 'Documented (Credible sources)',
  'pinForm.sourcesPlaceholder': 'Links or citations to sources...',
  'pinForm.nameRequired': 'Name is required',
  'pinForm.deleteConfirm': 'Are you sure you want to delete this pin? This cannot be undone.',
  'pinForm.deleteFailed': 'Delete failed',
  'pinForm.errorPrefix': 'Error',

  'event.showAllSuper': 'Show all (superadmin — incl. drafts)',
  'event.notFound': 'Event not found',
  'event.about': 'About',
  'event.culturalSignificance': 'Cultural Significance',
  'event.details': 'Details',
  'event.getTickets': 'Get Tickets',
  'event.recurring': 'Recurring',
  'event.participatingArtists': 'Participating Artists',
  'event.location': 'Location',
  'event.allEvents': 'All Events',
  'event.coordsHint': 'Set coordinates so the event appears on the map. Right-click any location in Google Maps → copy lat/lng.',
  'event.titleRequired': 'Title is required',
  'event.createFailed': 'Failed to create event',
  'event.titlePlaceholder': 'Event title',
  'event.describePlaceholder': 'Describe the event...',
  'event.venueExample': 'e.g. Tate Modern',
  'event.addressPlaceholder': 'Street address',
  'event.cityExample': 'e.g. London',
  'event.countryExample': 'e.g. United Kingdom',

  'myEvents.superadminView': 'Superadmin view — all events on the platform',
  'myEvents.yourEvents': 'Events you have created',
  'myEvents.showAllSuper': 'Show all (superadmin)',
  'myEvents.filter.all': 'All',
  'myEvents.filter.upcoming': 'Upcoming',
  'myEvents.filter.past': 'Past',
  'myEvents.filter.drafts': 'Drafts',
  'myEvents.loading': 'Loading...',
  'myEvents.loadFailed': 'Failed to load',
  'myEvents.empty.title': 'No events yet',
  'myEvents.empty.desc': 'Create your first event — it will appear here and on the public events page.',
  'myEvents.createBtn': 'Create Event',
  'myEvents.editBtn': 'Edit',
  'myEvents.showOnMapBtn': 'Show on Map',
  'myEvents.dateTba': 'Date TBA',
  'myEvents.statusPast': 'past',
  'myEvents.statusDraft': 'draft',

  'artworkDetail.about': 'About',
  'artworkDetail.details': 'Details',
  'artworkDetail.market': 'Market',
  'artworkDetail.qrCodes': 'QR Codes',
  'artworkDetail.lensDiscovery': 'Lens — Discovery',
  'artworkDetail.provenanceOwnership': 'Provenance — Ownership',
  'artworkDetail.scanLens': 'Scan to learn about this artwork and the artist',
  'artworkDetail.scanProvenance': 'Scan to view ownership chain and provenance history',
  'artworkDetail.view': 'View',
  'artworkDetail.print': 'Print',
  'artworkDetail.currentOwner': 'Current Owner',
  'artworkDetail.provenanceHistory': 'Provenance History',
  'artworkDetail.viewFullProvenance': 'View Full Provenance',
  'artworkDetail.tags': 'Tags',
  'artworkDetail.documentation': 'Documentation',
  'artworkDetail.exhibitionHistory': 'Exhibition History',
  'artworkDetail.claimPrompt': 'Are you the artist who created this work? Submit a claim to become the verified owner.',
  'artworkDetail.claimPlaceholder': 'Why are you claiming this artwork? (optional)',
  'artworkDetail.claimFailed': 'Failed to submit claim',
  'artworkDetail.claimPending': 'Your claim is pending admin review.',
  'artworkDetail.pricePlaceholder': 'e.g. €5,000',
  'artworkDetail.priceNote': 'Only you and the gallery/event organiser will see this price.',
  'artworkDetail.submitSent': 'Submission sent! The gallery will review your request.',
  'artworkDetail.submitFailed': 'Failed to submit',
  'artworkDetail.allArtworks': 'All Artworks',
  'artworkDetail.editArtwork': 'Edit Artwork',
  'artworkDetail.provenanceQr': 'Provenance QR',
  'artworkDetail.lensQrAlt': 'Lens QR',
  'artworkDetail.provenanceQrAlt': 'Provenance QR',

  'artworkCreate.titleRequired': 'Title is required',
  'artworkCreate.createFailed': 'Failed to create artwork',
  'artworkCreate.titlePlaceholder': 'Artwork title',
  'artworkCreate.artistPlaceholder': 'Artist name',
  'artworkCreate.yearExample': 'e.g. 2024',
  'artworkCreate.mediumExample': 'e.g. Oil on canvas',
  'artworkCreate.dimensionsExample': 'e.g. 120 x 80 cm',
  'artworkCreate.describePlaceholder': 'Describe the artwork...',
  'artworkCreate.imageLabel': 'Artwork Image',
  'artworkCreate.galleryPlaceholder': 'Gallery or museum name',
  'artworkDetail.viewArtwork': 'View artwork',

  // ── Artwork map location ("Pin Section") ────────────
  'artworkLocation.sectionTitle': 'Location on Map',
  'artworkLocation.showToggle': 'Show this artwork on the map',
  'artworkLocation.showHint': 'Off by default. Turn on to place a pin for this artwork at a specific address.',
  'artworkLocation.addressPlaceholder': 'e.g. City Library, 12 Main Street, Berlin',
  'artworkLocation.addressHint': "Enter an address — we'll locate the pin from it automatically.",
  'artworkLocation.locating': 'Locating address…',
  'artworkLocation.located': 'Pin location set',
  'artworkLocation.notFound': "Couldn't locate that address — try adding a city or country.",
  'artworkLocation.reason': "Reason it's on the map",
  'artworkLocation.reasonHint': 'Why is this artwork here now? e.g. exhibition, open studio, hanging in a public venue.',
  'artworkLocation.always': 'Show all the time (permanent location)',

  'myArtworks.deleteAllConfirm': 'Are you sure you want to delete all {n} artworks? This cannot be undone.',
  'myArtworks.releaseFailed': 'Failed to release artwork',
  'myArtworks.deleteConfirm': 'Permanently delete "{title}"? This cannot be undone — use Release instead if you only want to unclaim it.',
  'myArtworks.deleteFailed': 'Failed to delete artwork',

  'route.type.art_trail': 'Art Trail',
  'route.type.heritage': 'Heritage',
  'route.type.walking': 'Walking',
  'route.type.cycling': 'Cycling',
  'route.type.cultural': 'Cultural',
  'route.type.user_route': 'User Route',
  'routeDetail.forkConfirm': 'Fork this route? A copy will be added to your My Routes as a draft.',
  'routeDetail.forkFailed': 'Failed to fork',
  'routeDetail.deleteConfirm': 'Delete this route? This cannot be undone.',
  'routeDetail.deleteFailed': 'Failed to delete',
  'routeDetail.createdBy': 'Created by',
  'routeDetail.forkedFrom': 'Forked from',
  'routeDetail.days': 'days',
  'routeDetail.aboutThisRoute': 'About This Route',
  'routeDetail.highlights': 'Highlights',
  'routeDetail.culturalContext': 'Cultural Context',
  'routeDetail.waypoints': 'Waypoints',
  'routeDetail.directionsTo': 'Get directions to {name}',
  'routeDetail.tags': 'Tags',
  'routeDetail.allRoutes': 'All Routes',
  'routeDetail.fullInMaps': 'Full Route in Maps',
  'routeDetail.save': 'Save',
  'routeDetail.saved': 'Saved',
  'routeDetail.forking': 'Forking...',
  'routeDetail.forkRoute': 'Fork Route',
  'routeDetail.editRoute': 'Edit Route',
  'routeDetail.delete': 'Delete',
  'routeDetail.errorPrefix': 'Error',

  'routesList.deleteRoute': 'Delete route',
  'routesList.deleteConfirm': 'Delete route "{name}"? This cannot be undone.',
  'routesList.deleteFailed': 'Failed to delete',
  'routesList.fetchFailed': 'Failed to fetch routes',
  'routesList.ofTotal': 'of',

  'routeCreate.title': 'Create Route',
  'routeCreate.details': 'Route Details',
  'routeCreate.nameLabel': 'Name',
  'routeCreate.namePlaceholder': 'Route name',
  'routeCreate.descPlaceholder': 'Describe the route...',
  'routeCreate.imageLabel': 'Route Image',
  'routeCreate.imageUrlPlaceholder': 'https://example.com/route-image.jpg',
  'routeCreate.regionExample': 'e.g. Tuscany',
  'routeCreate.countryExample': 'e.g. Italy',
  'routeCreate.distanceLabel': 'Distance (km)',
  'routeCreate.distanceExample': 'e.g. 25',
  'routeCreate.durationLabel': 'Duration (days)',
  'routeCreate.durationExample': 'e.g. 3',
  'routeCreate.stops': 'Route Stops',
  'routeCreate.moveUp': 'Move up',
  'routeCreate.moveDown': 'Move down',
  'routeCreate.remove': 'Remove',
  'routeCreate.noStops': 'No stops added yet. Browse places below and tap + to add them.',
  'routeCreate.browsePlaces': 'Browse Places',
  'routeCreate.searchPlaces': 'Search places...',
  'routeCreate.loading': 'Loading...',
  'routeCreate.noPlaces': 'No places found matching your filters.',
  'routeCreate.alreadyAdded': 'Already added',
  'routeCreate.addAsStop': 'Add as route stop',
  'routeCreate.pageOf': 'Page {current} of {total}',
  'routeCreate.stop.one': '{n} stop',
  'routeCreate.stop.other': '{n} stops',
  'routeCreate.nameRequired': 'Name is required',

  'auth.loginFailed': 'Login failed. Please try again.',
  'auth.registrationFailed': 'Registration failed',

  'profileDetail.coverAlt': '{name} cover',
  'profileDetail.studio': 'Studio',
  'profileDetail.claimFailed': 'Failed to submit claim',
  'profileDetail.lensQr': 'Lens QR',

  'myProfile.releaseFailed': 'Failed to release profile',
  'myProfile.draftNotice.before': 'Your profile is in',
  'myProfile.draftNotice.middle': 'status and not yet visible to the public. Edit your profile and change the visibility to',
  'myProfile.draftNotice.after': 'when you\'re ready.',

  'bookmarks.savedOn': 'Saved',
  'bookmarks.removeBookmark': 'Remove bookmark',

  'search.placeholder': 'Search...',
  'search.placeholder.map': 'Search galleries, museums, studios...',
  'search.placeholder.discover': 'Search artists, events, articles...',
  'search.placeholder.routes': 'Search routes by name or description...',
  'search.placeholder.profiles': 'Search artists, collectives, curators...',
  'search.placeholder.articles': 'Search articles, reviews, guides...',
  'search.placeholder.events': 'Search events, venues, festivals...',
  'search.searchRadius': 'Search radius',
  'search.hideRadiusRing': 'Hide radius ring',
  'search.showRadiusRing': 'Show radius ring',
  'search.radiusLabel': 'Radius',
  'search.clear': 'Clear',
  'search.clearDates': 'Clear dates',
  'search.multipleLocations': 'Multiple locations — select one:',
  'search.hiddenCount': '{n} hidden',
  'search.pinTypesHidden.one': '{n} pin type hidden',
  'search.pinTypesHidden.other': '{n} pin types hidden',


  'article.category.gallery_spotlight': 'Gallery Spotlight',
  'article.category.artist_profile': 'Artist Profile',
  'article.category.exhibition_review': 'Exhibition Review',
  'article.category.cultural_insight': 'Cultural Insight',
  'article.category.route_guide': 'Route Guide',
  'article.category.news': 'News',
  'article.category.event': 'Event',
  'article.category.opinion': 'Opinion',

  'filter.label.routeType': 'Route Type',
  'filter.label.profileType': 'Profile Type',
  'filter.label.eventType': 'Event Type',
  'filter.label.discoverType': 'Category',
  'pricing.paypalFailed': 'Subscription was created on PayPal but failed to activate. Please contact support with your subscription ID:',

  'subscription.tier.freeVisibility': 'Free — Visibility',
  'subscription.tier.profile': 'Profile',
  'subscription.tier.pro': 'Pro',
  'subscription.tier.pioneer': 'Pioneer',

  'register.city': 'Your City / Town',
  'register.cityPlaceholder': 'e.g. Amsterdam, Berlin, Cape Town',
  'register.cityHelp': 'Used to center the map around your area',
  'register.showAddress': 'Show my pin and address on the map',
  'register.showAddressHelp': 'On by default so people can find and visit you. Uncheck to keep your address private — only your artworks and profile will be shown, with no map pin.',

  // ── batch 4: creates/wizards/filters/pricing ──
  'artworkCreate.title': 'Create Artwork',
  'eventCreate.title': 'Create Event',
  'routeCreate.addNew': 'Add new',
  'subscription.expires': 'Expires',
  'subscription.nextPayment': 'Next payment',
  'subscription.cancelConfirm': 'Cancel your subscription? You will keep access until the end of the current billing cycle.',
  'subscription.cancelFailed': 'Failed to cancel subscription',
  'subscription.noneActive': 'No active subscription',
  'subscription.viewPricing': 'View Pricing Plans',
  'subscription.managePlan': 'Manage Plan',
  'subscription.cancel': 'Cancel Subscription',
  'subscription.activated': 'Subscription activated successfully!',
  'subscription.activateFailed': 'Failed to activate subscription. Please contact support.',
  'subscription.failedLoad': 'Failed to load subscription',
  'myArtworks.deleteAll': 'Delete All',
  'myArtworks.deleting': 'Deleting...',
  'home.heroTitle': 'Discover Art Where It Lives',
  'home.heroSubtitle': 'ArtRouting connects artists, galleries and cultural places on a living map.',
  'home.openMap': 'Open the Map',
  'home.browseEvents': 'Browse Events',
  'contact.successMsg': 'Thanks — your message is on its way. We will reply soon.',
  'contact.errorMsg': 'Sorry, something went wrong. Please try again.',
  'contact.nameLabel': 'Your Name',
  'contact.emailLabel': 'Your Email',
  'contact.messageLabel': 'Your Message',
  'contact.submit': 'Send Message',
  'eventsList.activeFilters': 'Active filters',
  'eventsList.clearFilters': 'Clear all',
  'eventsList.filterCountry': 'Country',
  'eventsList.filterCity': 'City',
  'eventsList.filterSearch': 'Search',
  'eventsList.filterType': 'Type',

  // ── ArtRadar Newspaper (territorial cultural newspaper) ──────
  'article.category.interview': 'Interview',
  'article.category.opportunity': 'Opportunity',
  'article.category.educational_guide': 'Educational Guide',
  'article.category.heritage_story': 'Heritage Story',

  'artradar.newspaper.title': 'ArtRadar Newspaper',
  'artradar.worldEdition': 'World Edition',
  'artradar.worldEdition.tagline': 'A global mix of artists, places, opportunities and editorial voice — pick a territory to see what is near you.',
  'artradar.territory.tagline': 'The art world from {name} — near me, this week, and beyond.',
  'artradar.territory.viewEdition': 'Open the territorial edition',
  'artradar.viewAll': 'View all',
  'artradar.viewAsList': 'List view',
  'artradar.empty': 'No stories here yet. Try the World Edition or another territory.',

  'artradar.territorySelector.label': 'Choose your territory',
  'artradar.territorySelector.useLocation': 'Use my location',
  'artradar.territorySelector.locating': 'Locating…',
  'artradar.territorySelector.locationDenied': 'Location permission denied — staying with current selection.',
  'artradar.territorySelector.locationFailed': 'Could not match your location to a territory. Showing World Edition.',
  'artradar.territorySelector.locationUnsupported': 'Geolocation is not supported in this browser.',
  'artradar.territorySelector.outsideKnown': 'You are outside the known territories — showing World Edition.',

  'artradar.section.near_me': 'Near Me',
  'artradar.section.near_me.tagline': 'What is happening inside the territory you are viewing.',
  'artradar.section.this_week': 'This Week',
  'artradar.section.this_week.tagline': 'Openings, events, and stories that matter this week.',
  'artradar.section.artists': 'Artists',
  'artradar.section.artists.tagline': 'Profiles, interviews, and studio visits.',
  'artradar.section.places': 'Places',
  'artradar.section.places.tagline': 'Galleries, museums, studios, and cultural destinations.',
  'artradar.section.opportunities': 'Opportunities',
  'artradar.section.opportunities.tagline': 'Open calls, residencies, grants, and invitations.',
  'artradar.section.learn': 'Learn',
  'artradar.section.learn.tagline': 'Guidance for artists, galleries, curators, and visitors.',
  'artradar.section.cultural_stories': 'Cultural Stories',
  'artradar.section.cultural_stories.tagline': 'Heritage, history, and why a place matters.',
  'artradar.section.explore': 'Explore',
  'artradar.section.explore.tagline': 'Other regions, countries, and rural art destinations.',
  'artradar.section.editors_desk': "Editor's Desk",
  'artradar.section.editors_desk.tagline': 'Opinion, research, and ArtRouting voice.',
  'artradar.section.editors_picks': "Editor's Picks",
  'artradar.section.editors_picks.tagline': 'Hand-picked stories from across the world.',
  'artradar.sponsored': 'Sponsored',
  'artradar.sponsoredHint': 'This article is a paid placement.',
  'artradar.linkedFromMap': 'Read in ArtRadar',
  'artradar.relatedStories': 'Related stories',
  'artradar.newspaperTitle': 'ArtRadar Newspaper',

  // Special editions / page-turn (§15)
  'artradar.editionsTitle': 'Special Editions',
  'artradar.editionsSubtitle': 'Curated ArtRadar issues — weekly, seasonal, and territorial specials.',
  'artradar.noEditions': 'No special editions published yet.',
  'artradar.allEditions': 'All Editions',
  'artradar.specialEdition': 'Special Edition',
  'artradar.editionNotFound': 'Edition not found',
  'artradar.cover': 'Cover',
  'artradar.editionPages': 'pages',
  'artradar.readFullArticle': 'Read full article',
  'artradar.previousPage': 'Previous page',
  'artradar.nextPage': 'Next page',
  'artradar.manageEditions': 'Manage Editions',

  // Admin collections
  'admin.collections.title': 'Manage Special Editions',
  'admin.collections.subtitle': 'Create and arrange ArtRadar editions — weekly, seasonal, exhibition catalogues, premium issues.',
  'admin.collections.viewPublic': 'Public View',
  'admin.collections.newEdition': 'New Edition',
  'admin.collections.empty': 'No editions yet. Create the first one.',
  'admin.collections.back': 'Back to editions list',
  'admin.collections.titleRequired': 'Title is required',
  'admin.collections.fieldTitle': 'Title',
  'admin.collections.fieldDescription': 'Description',
  'admin.collections.fieldCover': 'Cover image URL',
  'admin.collections.fieldType': 'Edition type',
  'admin.collections.fieldTerritory': 'Territory',
  'admin.collections.fieldStatus': 'Status',
  'admin.collections.fieldArticles': 'Articles in this edition',
  'admin.collections.articlesHint': 'Tick articles to include. Reorder with the arrows — readers see them as pages in this order.',
  'admin.collections.pageOrder': 'Page order',
  'admin.collections.searchArticles': 'Search published articles…',
  'admin.collections.delete': 'Delete edition',
  'admin.collections.deleteConfirm': 'Delete this edition? Articles themselves are not deleted.',

  // ── Artwork Story (Artwork PIN) ──────────────────────────────
  'story.pageTitle': 'Artwork Story',
  'story.subtitle': 'The story behind this artwork, told by the artist.',
  'story.loading': 'Loading the story…',
  'story.notFound': 'This artwork could not be found.',
  'story.backToArtwork': 'Back to artwork',
  'story.draftBadge': 'Draft — only you can see this',
  'story.editStory': 'Edit story',
  'story.viewStoryLink': 'Read the story',
  'story.playAll': 'Play complete story',
  'story.stopAll': 'Stop narration',
  'story.listen': 'Listen to this section',
  'story.stopListening': 'Stop listening',
  'story.expandAll': 'Expand all',
  'story.collapseAll': 'Collapse all',
  'story.narrationUnsupported': 'Voice narration is not available in this browser.',
  'story.noStoryYet': 'The artist has not published a story for this artwork yet.',
  'story.noStoryYetOwner': 'You have not written a story for this artwork yet.',
  'story.writeStory': 'Write the story',
  'story.languageHint': 'Read and listen in your preferred language.',

  'story.section.welcome': 'Welcome',
  'story.section.artist': 'About the Artist',
  'story.section.info': 'Artwork Information',
  'story.section.storyBehind': 'The Story Behind the Artwork',
  'story.section.process': 'Creative Process',
  'story.section.details': 'Details to Notice',
  'story.section.context': 'Context',
  'story.section.journey': 'Artwork Journey',
  'story.section.related': 'Related Content',
  'story.section.reflection': "Artist's Reflection",
  'story.section.explore': 'Continue Exploring',

  'story.field.bio': 'Short biography',
  'story.field.philosophy': 'Artistic philosophy',
  'story.field.background': 'Artistic background',
  'story.field.themes': 'Main themes explored',
  'story.field.studioLocation': 'Studio location',
  'story.field.website': 'Website / Portfolio',
  'story.field.title': 'Title',
  'story.field.year': 'Year',
  'story.field.medium': 'Medium',
  'story.field.materials': 'Materials',
  'story.field.dimensions': 'Dimensions',
  'story.field.weight': 'Weight',
  'story.field.series': 'Series',
  'story.field.edition': 'Edition',
  'story.field.status': 'Current status',
  'story.field.pinNumber': 'Artwork PIN number',

  'story.prompt.welcome': 'A short welcome introducing the visitor to this artwork.',
  'story.prompt.storyBehind': 'What inspired this artwork? Why did you create it? What emotions were present? What message does it carry? Is there a hidden meaning?',
  'story.prompt.process': 'Techniques used, materials, time required, challenges encountered, interesting discoveries.',
  'story.prompt.details': 'Hidden details, symbolism, colour choices, texture, composition, small elements often overlooked.',
  'story.prompt.context': 'Historical or cultural references, literature, nature, music, personal experiences, related artworks.',
  'story.prompt.reflection': 'What did this artwork teach you? Would you create it differently today? What do you hope visitors take away?',

  'story.journey.exhibitions': 'Exhibitions',
  'story.journey.provenance': 'Recorded events',
  'story.journey.empty': 'This artwork has no recorded exhibitions yet.',
  'story.related.empty': 'No related articles yet.',
  'story.explore.artistProfile': 'Artist profile',
  'story.explore.otherArtworks': 'Other artworks',
  'story.explore.nearbyArt': 'Where to see it',
  'story.explore.empty': 'Nothing to explore yet.',

  'story.edit.title': 'Edit Artwork Story',
  'story.edit.intro': 'Write once — ArtRouting presents your story in the visitor’s language and reads it aloud.',
  'story.edit.save': 'Save story',
  'story.edit.saving': 'Saving…',
  'story.edit.saved': 'Story saved.',
  'story.edit.saveError': 'The story could not be saved. Please try again.',
  'story.edit.loadError': 'The story could not be loaded.',
  'story.edit.forbidden': 'You do not have permission to edit this story.',
  'story.edit.publish': 'Publish this story',
  'story.edit.publishHint': 'While unpublished, only you can see the story.',
  'story.edit.autoTranslateHint': 'Translations into the other language are generated automatically.',
  'story.edit.imageUrl': 'Image URL (optional)',
  'story.edit.videoUrl': 'Video URL (optional)',
  'story.edit.viewStory': 'View story',
  'story.edit.optional': 'Optional',
  'story.edit.required': 'Required',
  // ── Superadmin in-place text editing ───────────────────
  'textEditor.enter': 'Edit text',
  'textEditor.exit': 'Done editing',
  'textEditor.banner': 'Edit mode is on. Click any highlighted text to change it in English and German.',
  'textEditor.title': 'Edit this text',
  'textEditor.browseTitle': 'All text on this page',
  'textEditor.hint': 'Both languages are saved together. The change is live on the site as soon as you save.',
  'textEditor.browseHint': 'Everything this page shows, including text inside tooltips, placeholders and dropdowns.',
  'textEditor.close': 'Close',
  'textEditor.english': 'English',
  'textEditor.german': 'German',
  'textEditor.englishPlaceholder': 'The English wording',
  'textEditor.germanPlaceholder': 'The German wording',
  'textEditor.bothRequired': 'Please fill in both the English and the German text.',
  'textEditor.saveFailed': 'That could not be saved. Please try again.',
  'textEditor.save': 'Save',
  'textEditor.cancel': 'Cancel',
  'textEditor.reset': 'Restore original',
  'textEditor.resetConfirm': 'Restore the original wording for this text?',
  'textEditor.pageList': 'All text on this page',
  'textEditor.pageListHint': 'Pick any entry to edit it.',
  'textEditor.searchPlaceholder': 'Search this page',
  'textEditor.noMatches': 'Nothing matches that search.',
  'textEditor.toolbar': 'Formatting',
  'textEditor.bold': 'Bold',
  'textEditor.italic': 'Italic',
  'textEditor.underline': 'Underline',
  'textEditor.link': 'Link',
  'textEditor.bullet': 'Bullet list',
  'textEditor.lineBreak': 'Line break',
  'textEditor.preview': 'Preview',
  'textEditor.previewEmpty': 'Nothing to show yet.',
  'textEditor.sampleBold': 'bold text',
  'textEditor.sampleItalic': 'italic text',
  'textEditor.sampleUnderline': 'underlined text',
  'textEditor.sampleLink': 'link text',
  // ── Developer API (API keys + explorer) ────────────────────────
  'nav.developerApi': 'Developer API',

  'developer.title': 'Developer API',
  'developer.subtitle': 'Give a script, an app or a partner system the same access you have in the browser. A key reads and writes your records over the API, limited to the scopes you give it.',
  'developer.tab.keys': 'API keys',
  'developer.tab.explorer': 'API explorer',
  'developer.scope.read': 'read',
  'developer.scope.write': 'write',

  'developer.keys.createTitle': 'Create a key',
  'developer.keys.createIntro': 'Name the key after the thing that will use it, so you know what you are switching off if you ever revoke it.',
  'developer.keys.nameLabel': 'Key name',
  'developer.keys.namePlaceholder': 'Gallery import script',
  'developer.keys.nameRequired': 'Please give the key a name.',
  'developer.keys.scopesLabel': 'What this key may do',
  'developer.keys.scopesHint': 'Give the key only what it needs. A key can never manage your account, your billing or your other keys.',
  'developer.keys.scopeRequired': 'Please choose at least one scope.',
  'developer.keys.allowance': '{used} of {limit} keys in use.',
  'developer.keys.createButton': 'Create key',
  'developer.keys.creating': 'Creating…',
  'developer.keys.createError': 'The key could not be created.',
  'developer.keys.loadError': 'Your keys could not be loaded.',
  'developer.keys.needsPlan': 'API keys are part of the paid plans.',
  'developer.keys.seePlans': 'See plans',
  'developer.keys.secretTitle': 'Your new key',
  'developer.keys.secretOnce': 'This is the only time the key is shown. Copy it into your script or password manager now — ArtRouting stores only a hash of it.',
  'developer.keys.copy': 'Copy',
  'developer.keys.copied': 'Copied',
  'developer.keys.dismiss': 'Done',
  'developer.keys.listTitle': 'Your keys',
  'developer.keys.listIntro': 'Rotating issues a new secret and stops the old one at once. Revoking keeps the key and its history but stops it working.',
  'developer.keys.loading': 'Loading…',
  'developer.keys.empty': 'No keys yet.',
  'developer.keys.revoked': 'revoked',
  'developer.keys.createdAt': 'Created',
  'developer.keys.lastUsed': 'Last used',
  'developer.keys.never': 'never',
  'developer.keys.rotate': 'Rotate',
  'developer.keys.rotateConfirm': 'Issue a new secret for this key? Anything still using the old secret stops working immediately.',
  'developer.keys.rotateError': 'The key could not be rotated.',
  'developer.keys.revoke': 'Revoke',
  'developer.keys.revokeConfirm': 'Revoke this key? It stops working immediately and cannot be re-enabled.',
  'developer.keys.revokeError': 'The key could not be revoked.',
  'developer.keys.delete': 'Delete',
  'developer.keys.deleteConfirm': 'Delete this key and its usage history permanently?',
  'developer.keys.deleteError': 'The key could not be deleted.',
  'developer.keys.showUsage': 'Usage',
  'developer.keys.hideUsage': 'Hide usage',
  'developer.keys.usageError': 'The usage log could not be loaded.',
  'developer.keys.usageEmpty': 'This key has not been used yet.',
  'developer.keys.statTotal': 'Calls',
  'developer.keys.stat24h': 'Last 24 h',
  'developer.keys.statErrors': 'Errors 24 h',
  'developer.keys.statAvg': 'Average',
  'developer.keys.usingTitle': 'Using a key',
  'developer.keys.usingIntro': 'Send the key on every call in the X-API-Key header. It acts as your account, within its scopes, and every call is counted against the key.',
  'developer.keys.tryHint': 'Try any endpoint from the',

  'developer.explorer.title': 'API explorer',
  'developer.explorer.subtitle': 'Every endpoint ArtRouting publishes, read from the live API, and runnable right here while you are signed in.',
  'developer.explorer.specError': 'The API description could not be loaded.',
  'developer.explorer.runError': 'The call could not be made.',
  'developer.explorer.authTitle': 'How to authenticate',
  'developer.explorer.authIntro': 'Calls from this page go to the real API and change real records. Choose what to send them as.',
  'developer.explorer.auth.session': 'My session',
  'developer.explorer.auth.key': 'An API key',
  'developer.explorer.auth.none': 'No authentication',
  'developer.explorer.keyLabel': 'API key',
  'developer.explorer.keyHint': 'The key is used only in this browser tab. Create or rotate keys under',
  'developer.explorer.loading': 'Loading the API description…',
  'developer.explorer.filterLabel': 'Find an endpoint',
  'developer.explorer.filterPlaceholder': 'pins, artwork, provenance…',
  'developer.explorer.noMatches': 'No endpoint matches.',
  'developer.explorer.requiresAuth': 'needs authentication',
  'developer.explorer.parameters': 'Parameters',
  'developer.explorer.body': 'Request body (JSON)',
  'developer.explorer.send': 'Send request',
  'developer.explorer.sending': 'Sending…',
  'developer.explorer.copyCurl': 'Copy as curl',

  // Legal: Authorship + Messaging rules (Impressum additions)
  'footer.authorshipRules': 'Authorship Rules',
  'footer.messagingRules': 'Messaging Rules',
  'legal.impressumMoreTitle': 'Further legal information',
  'legal.authorshipTitle': 'Authorship / Delegated Editing Rights',
  'legal.authorship.s1Title': 'What Authorship means',
  'legal.authorship.s1Body': 'ArtRouting Authorship allows the owner of an ArtRouting profile, artwork, exhibition, venue or other eligible record to grant a named person permission to help manage selected content on their behalf. Authorship does not transfer ownership of the profile, artwork, copyright or account.',
  'legal.authorship.s2Title': 'Consent by both parties',
  'legal.authorship.s2Body': 'Authorship becomes active only after the owner sends an invitation and the invited author accepts it. Both parties must accept the applicable Authorship rules before access is activated.',
  'legal.authorship.s3Title': 'Owner remains in control',
  'legal.authorship.s3Body': 'The owner decides which person receives access and may revoke that access at any time. The owner remains the primary account holder and retains overall control of the relevant ArtRouting records.',
  'legal.authorship.s4Title': 'What an authorised author may do',
  'legal.authorship.s4Body': 'Depending on the permissions granted, an authorised author may edit profile information, artworks, exhibitions, events, location information and eligible ArtRadar submissions. Access should be limited to the permissions selected by the owner.',
  'legal.authorship.s5Title': 'What an authorised author may not do',
  'legal.authorship.s5Body': 'An authorised author may not claim ownership of another person’s work or identity, transfer rights to another person, use the access for unrelated advertising or sponsorship, or make changes outside the permissions granted by the owner.',
  'legal.authorship.s6Title': 'Change history and notifications',
  'legal.authorship.s6Body': 'Changes made through Authorship should be recorded in an audit history. The owner should be able to see who made a change and when, and should receive notifications for relevant changes.',
  'legal.authorship.s7Title': 'Revocation and suspension',
  'legal.authorship.s7Body': 'The owner may revoke an author’s access at any time. ArtRouting may also restrict, suspend or remove Authorship access where the feature is misused, where rights are disputed, or where platform rules are breached.',
  'legal.authorship.s8Title': 'Responsibility for content',
  'legal.authorship.s8Body': 'Owners and authorised authors are responsible for ensuring that information, images and other materials they add are accurate and that they have the necessary rights or permissions to publish them.',
  'legal.authorship.s9Title': 'No transfer of copyright or legal ownership',
  'legal.authorship.s9Body': 'Authorship is an administrative permission only. It does not transfer copyright, moral rights, ownership of artworks, contractual rights, representation rights or any other legal ownership unless a separate agreement exists outside ArtRouting.',
  'legal.authorship.acceptTitle': 'Required Acceptance Before Activation',
  'legal.authorship.acceptHelp': 'These statements must be confirmed in the Authorship workflow before access is enabled.',
  'legal.authorship.acceptOwner1': 'Owner: I confirm that I am authorised to grant this person editing access to the selected ArtRouting content.',
  'legal.authorship.acceptOwner2': 'Owner: I understand that I remain responsible for the account and may revoke access at any time.',
  'legal.authorship.acceptAuthor1': 'Author: I accept only the permissions granted to me and will not present myself as the owner unless separately authorised.',
  'legal.authorship.acceptAuthor2': 'Author: I will only upload or edit material that I am entitled to use.',
  'legal.authorship.acceptBoth': 'Both parties: We accept the ArtRouting Authorship Rules and understand that access may be suspended or revoked if the feature is misused.',
  'legal.authorship.openWorkflow': 'Go to Delegated Authorship',
  'legal.messagingTitle': 'Private Messaging / Communication Rules',
  'legal.messaging.s1Title': 'What ArtRouting Messaging is',
  'legal.messaging.s1Body': 'ArtRouting Messaging is a private communication feature for registered users. It is intended to support legitimate art-related communication such as visit requests, price enquiries, exhibition invitations, professional introductions, recommendations, calls and competitions, and other relevant communication between participants.',
  'legal.messaging.s2Title': 'Private, not public',
  'legal.messaging.s2Body': 'Messages are not public comments. They are intended for the sender and recipient or, where group messaging is available, the invited participants of that conversation.',
  'legal.messaging.s3Title': 'Identity and context',
  'legal.messaging.s3Body': 'Messages should be connected to the sender’s registered ArtRouting identity. Where relevant, the interface may show the sender’s name, role, city/country, professional specialisation and the profile, artwork, venue, exhibition, invitation or QR context from which the message was sent.',
  'legal.messaging.s4Title': 'No spam or mass unsolicited messaging',
  'legal.messaging.s4Body': 'Users may not use ArtRouting Messaging to send repetitive unsolicited messages, bulk advertising, deceptive promotions, automated spam or unrelated commercial marketing. ArtRouting may apply technical limits, rate controls and spam detection to reduce abusive messaging.',
  'legal.messaging.s5Title': 'Invitations to join ArtRouting',
  'legal.messaging.s5Body': 'Users may invite an external artist, venue, heritage custodian or other relevant person to join ArtRouting where the invitation has a genuine connection to art, an article, an artwork, an exhibition or another relevant ArtRouting activity. Invitations must not be used for indiscriminate bulk outreach.',
  'legal.messaging.s6Title': 'Respectful and lawful use',
  'legal.messaging.s6Body': 'Users must not use Messaging for harassment, threats, fraud, impersonation, unlawful content, infringement of rights, or other abusive conduct.',
  'legal.messaging.s7Title': 'Attachments and shared material',
  'legal.messaging.s7Body': 'A sender is responsible for ensuring that files, images, links and other material shared through Messaging may lawfully be shared and do not infringe third-party rights.',
  'legal.messaging.s8Title': 'Connection requests',
  'legal.messaging.s8Body': 'Where ArtRouting provides connection requests, the recipient may accept or decline them. A declined or unanswered request does not create permission for repeated contact.',
  'legal.messaging.s9Title': 'Blocking, reporting and moderation',
  'legal.messaging.s9Body': 'Users should be able to block or report inappropriate messaging. ArtRouting may investigate reports and may restrict, suspend or remove messaging access where the feature is misused.',
  'legal.messaging.s10Title': 'Message retention and privacy',
  'legal.messaging.s10Body': 'ArtRouting should describe message retention, deletion and privacy handling in its Privacy Policy. Private messages should not be presented as publicly visible content.',
  'legal.messaging.s11Title': 'No guarantee of response',
  'legal.messaging.s11Body': 'Receiving a message, invitation, visit request or enquiry through ArtRouting does not oblige the recipient to respond, accept a request, sell an artwork, arrange a visit or enter into any agreement.',
  'legal.messaging.confirmTitle': 'User Confirmation',
  'legal.messaging.confirm1': 'I will use ArtRouting Messaging for relevant and lawful communication.',
  'legal.messaging.confirm2': 'I will not send spam, repetitive unsolicited advertising or abusive messages.',
  'legal.messaging.confirm3': 'I understand that recipients may decline, block or report contact.',
  'legal.messaging.confirm4': 'I am responsible for material and attachments that I send.',
  'legal.messaging.confirm5': 'I accept the ArtRouting Messaging Rules.',
  'legal.messaging.privacyLink': 'Privacy Policy',
  'legal.messaging.blockHowTo': 'To block someone, open the conversation menu in Messages and choose Block. People you have blocked are listed under Privacy in your Messages menu. To report misuse, write to info@artrouting.com.',
  'messaging.rulesGateTitle': 'Before you start messaging',
  'messaging.rulesGateHelp': 'Please confirm each statement once. They are part of the ArtRouting Messaging Rules.',
  'messaging.rulesGateAccept': 'Confirm and continue',
  'messaging.rulesLink': 'Messaging Rules',
  'messaging.errRulesNotAccepted': 'Please confirm the Messaging Rules before sending.',
  'authorship.legal.title': 'Required acceptance before activation',
  'authorship.legal.readFull': 'Read the full Authorship Rules',

  // ArtRadar — open to every member (contributors, submissions, review)
  'artradar.submitArticle': 'Submit Article',
  'artradar.learnMore': 'What is ArtRadar?',
  'artradar.guidelinesLink': 'Contributor Guidelines',
  'artradar.welcomeLine': 'ArtRadar welcomes contributions from registered ArtRouting users. All submissions are reviewed before publication.',
  'artradar.about.title': 'What is ArtRadar?',
  'artradar.about.p1': 'ArtRadar is ArtRouting’s geographical editorial layer. Stories about artists, artworks, exhibitions, art venues, heritage and cultural activity are connected to the places and records they concern.',
  'artradar.about.p2': 'Local stories can be discovered in the relevant town or area, region and country. Selected stories of wider relevance may also be featured in the World Edition.',
  'artradar.about.p3': 'General or international articles that are not tied to one location may still be submitted, but World Edition placement is curated and not automatic.',
  'artradar.about.p4': 'Your own city does not decide where an article belongs: its location follows the subject of the story.',
  'artradar.about.p5': 'Everyone registered on ArtRouting can contribute, on every tier and in every role: artists, art venues, explorers, heritage representatives, and the writers of local newspapers and magazines. Your name and publication are credited on every article, so a story copied elsewhere can always be traced back to you and your publication.',
  'artradar.about.start': 'Submit an article',
  'artradar.guidelines.title': 'Contributor Guidelines',
  'artradar.guidelines.1': 'Register once: your name, how you write and, if you write for one, your newspaper or magazine. ArtRouting remembers them and credits every article you submit.',
  'artradar.guidelines.2': 'Write about something real: an artist, artwork, exhibition, art venue, heritage record or place. Connect the article to its ArtRouting records, or invite the people involved to join.',
  'artradar.guidelines.3': 'You are responsible for the accuracy of what you submit and for the rights to its text and images. For every image, say on what basis it may be published.',
  'artradar.guidelines.4': 'If the article has already appeared elsewhere, name the original publication, link and date, and confirm that you or your organisation may republish it.',
  'artradar.guidelines.5': 'Every submission is reviewed before publication. The editors may ask for changes, decline, correct, place or remove an article.',
  'artradar.guidelines.6': 'Paid, sponsored or otherwise commercial content must be declared as such.',
  'artradar.contributor.title': 'Your ArtRadar contributor details',
  'artradar.contributor.intro': 'You fill this in once. ArtRouting remembers it and shows it on every article you submit, so readers, and anyone who finds your article elsewhere, can see who wrote it and for which publication.',
  'artradar.contributor.fullName': 'Full name',
  'artradar.contributor.type': 'You write as',
  'artradar.contributor.type.journalist': 'Journalist',
  'artradar.contributor.type.curator': 'Curator',
  'artradar.contributor.type.researcher': 'Researcher',
  'artradar.contributor.type.historian': 'Historian',
  'artradar.contributor.type.educator': 'Educator',
  'artradar.contributor.type.artist': 'Artist',
  'artradar.contributor.type.art_venue': 'Art Venue',
  'artradar.contributor.type.heritage': 'Heritage representative',
  'artradar.contributor.type.explorer': 'Explorer',
  'artradar.contributor.type.other': 'Other',
  'artradar.contributor.choose': 'Choose…',
  'artradar.contributor.publication': 'Newspaper, magazine or organisation (optional)',
  'artradar.contributor.publicationPh': 'e.g. Oudtshoorn Courant',
  'artradar.contributor.publicationUrl': 'Link to the newspaper or magazine (optional)',
  'artradar.contributor.publicationUrlHint': 'Shown as a link on every article you publish.',
  'artradar.contributor.city': 'City',
  'artradar.contributor.country': 'Country',
  'artradar.contributor.bio': 'Short professional description',
  'artradar.contributor.website': 'Website or professional link (optional)',
  'artradar.contributor.acceptRules': 'I accept the ArtRadar editorial rules and Contributor Guidelines.',
  'artradar.contributor.acceptRights': 'I confirm that I am responsible for the rights and permissions of the material I submit.',
  'artradar.contributor.save': 'Save and continue',
  'artradar.contributor.saveChanges': 'Save changes',
  'artradar.contributor.saved': 'Contributor details saved.',
  'artradar.contributor.edit': 'Contributor details',
  'artradar.contributor.suspended': 'Your ArtRadar submissions are suspended. Your ArtRouting account is not affected. Please contact the editors.',
  'artradar.err.full_name_required': 'Please enter your full name.',
  'artradar.err.contributor_type_required': 'Please choose how you write.',
  'artradar.err.invalid_publication_url': 'The newspaper or magazine link is not a valid web address.',
  'artradar.err.invalid_website_url': 'The website link is not a valid web address.',
  'artradar.err.acceptance_required': 'Please accept the editorial rules and confirm your responsibility for rights.',
  'artradar.err.contributor_required': 'Please register your contributor details first.',
  'artradar.err.contributor_suspended': 'Your ArtRadar submissions are suspended.',
  'artradar.err.not_your_article': 'This article belongs to another contributor.',
  'artradar.err.locked_in_review': 'This article is with the editors and cannot be changed until they respond.',
  'artradar.err.title_required': 'Please add a title.',
  'artradar.err.body_required': 'Please add the article text.',
  'artradar.err.rights_missing': 'Please choose the rights basis for every image.',
  'artradar.err.republish_missing': 'Please confirm the republishing rights.',
  'artradar.err.generic': 'Something went wrong. Please try again.',
  'artradar.submit.title': 'Submit an article',
  'artradar.submit.editTitle': 'Edit your article',
  'artradar.submit.steps': 'Write · Connect or Invite · Confirm rights · Submit for review',
  'artradar.submit.creditPreview': 'Your article will be credited as',
  'artradar.submit.articleTitle': 'Article title',
  'artradar.submit.excerpt': 'Short summary',
  'artradar.submit.body': 'Article text',
  'artradar.submit.category': 'Category',
  'artradar.submit.geo': 'Geographical relevance',
  'artradar.submit.geo.specific': 'A specific location',
  'artradar.submit.geo.multiple': 'Several locations',
  'artradar.submit.geo.general': 'General or international',
  'artradar.submit.geoHint': 'The location follows the subject of the story, not where you live.',
  'artradar.submit.city': 'Town or area',
  'artradar.submit.country': 'Country',
  'artradar.submit.worldEdition': 'This story has wider relevance: suggest it for the World Edition (the editors decide).',
  'artradar.submit.dates': 'Dates, if time-sensitive',
  'artradar.submit.datesPh': 'e.g. 3–28 October 2026',
  'artradar.submit.sources': 'Sources',
  'artradar.submit.images': 'Images',
  'artradar.submit.imagesHint': 'The first image is the cover. Up to 10 more appear with the article.',
  'artradar.submit.addImage': 'Add image',
  'artradar.submit.uploading': 'Uploading…',
  'artradar.submit.removeImage': 'Remove image',
  'artradar.submit.imageCredit': 'Photographer / image credit',
  'artradar.submit.rights': 'Rights for this image',
  'artradar.rights.choose': 'Choose the rights basis…',
  'artradar.rights.own': 'I am the rights holder / I created this image',
  'artradar.rights.permission': 'I have permission to publish this image on ArtRouting',
  'artradar.rights.approved_via_artrouting': 'The rights holder approved this image through ArtRouting',
  'artradar.rights.public_domain': 'Public domain or otherwise legally reusable',
  'artradar.rights.unsure': 'I am unsure / permission is required',
  'artradar.rights.requestPermission': 'Request permission',
  'artradar.rights.requestSubject': 'Permission request: an image for ArtRadar on ArtRouting',
  'artradar.rights.requestBody': 'Hello,\n\nI would like to publish this image in an ArtRadar article on ArtRouting (artrouting.com):\n{url}\n\nArticle: {title}\nProposed credit: {credit}\nRequested by: {name}\n\nPlease reply to approve or decline.\n\nThank you.',
  'artradar.submit.republished': 'This article was previously published elsewhere',
  'artradar.submit.origPublication': 'Original publication',
  'artradar.submit.origUrl': 'Link to the original',
  'artradar.submit.origDate': 'Original publication date',
  'artradar.submit.republishRights': 'I confirm that I or my organisation have the rights to republish this text and its images on ArtRouting, or I have marked the images that need separate permission.',
  'artradar.submit.connect': 'Connect or Invite',
  'artradar.submit.connectHint': 'Search ArtRouting for the people, artworks, venues, exhibitions, heritage records and places your article mentions. If they are not on ArtRouting yet, invite them.',
  'artradar.submit.searchPh': 'Search artists, artworks, places, exhibitions…',
  'artradar.submit.search': 'Search',
  'artradar.submit.connectAction': 'Connect',
  'artradar.submit.disconnect': 'Remove connection',
  'artradar.submit.connected': 'Connected',
  'artradar.submit.noResults': 'Nothing found on ArtRouting. Invite them below.',
  'artradar.connect.kind.profile': 'Artist / profile',
  'artradar.connect.kind.pin': 'Place / venue',
  'artradar.connect.kind.event': 'Exhibition / event',
  'artradar.connect.kind.artwork': 'Artwork',
  'artradar.invite.title': 'Invite someone who is not on ArtRouting yet',
  'artradar.invite.name': 'Name',
  'artradar.invite.kind': 'Who or what',
  'artradar.invite.kind.person': 'Person',
  'artradar.invite.kind.artwork': 'Artwork',
  'artradar.invite.kind.venue': 'Art venue',
  'artradar.invite.kind.exhibition': 'Exhibition',
  'artradar.invite.kind.heritage': 'Heritage record',
  'artradar.invite.kind.place': 'Place',
  'artradar.invite.contact': 'Email or phone (optional)',
  'artradar.invite.email': 'Email',
  'artradar.invite.whatsapp': 'WhatsApp',
  'artradar.invite.copy': 'Copy link',
  'artradar.invite.copied': 'Invitation copied',
  'artradar.invite.subject': 'You have been mentioned on ArtRadar',
  'artradar.invite.message': 'You have been mentioned in an ArtRadar article on ArtRouting: "{title}". You are invited to join ArtRouting and connect your profile, artwork or place to the article: {url}',
  'artradar.invite.sent': 'Invitation sent',
  'artradar.invite.awaiting': 'Awaiting connection',
  'artradar.invite.remove': 'Remove invitation',
  'artradar.submit.saveDraft': 'Save draft',
  'artradar.submit.submit': 'Submit for review',
  'artradar.submit.submittedMsg': 'Thank you. Your article has been submitted and will be reviewed before publication.',
  'artradar.submit.draftSaved': 'Draft saved.',
  'artradar.submit.toMyArticles': 'Go to My Articles',
  'artradar.review.draft': 'Draft',
  'artradar.review.submitted': 'Submitted',
  'artradar.review.under_review': 'Under review',
  'artradar.review.changes_requested': 'Changes requested',
  'artradar.review.approved': 'Approved',
  'artradar.review.published': 'Published',
  'artradar.review.declined': 'Declined',
  'artradar.review.revoked': 'Revoked',
  'artradar.review.archived': 'Archived',
  'artradar.review.notes': 'Notes from the editors',
  'artradar.credit.by': 'By',
  'artradar.credit.roles': 'On ArtRouting',
  'artradar.credit.firstPublished': 'First published in {name}',
  'artradar.credit.readOriginal': 'Read the original',
  'artradar.credit.images': 'Images',
  'artradar.credit.sources': 'Sources',
  'artradar.credit.visitPublication': 'Visit {name}',
  'artradar.role.artist': 'Artist',
  'artradar.role.gallery': 'Art Venue',
  'artradar.role.explorer': 'Explorer',
  'artradar.role.curator': 'Curator',
  'artradar.role.collective': 'Collective',
  'admin.artradar.title': 'ArtRadar review',
  'admin.artradar.desc': 'Review member submissions, image rights, invitations and contributors.',
  'admin.artradar.cardStat': 'Open to',
  'admin.artradar.cardStatValue': 'Every tier',
  'admin.artradar.cardCta': 'Review',
  'admin.artradar.queue': 'Submissions',
  'admin.artradar.contributors': 'Contributors',
  'admin.artradar.filterOpen': 'Open',
  'admin.artradar.empty': 'No submissions here.',
  'admin.artradar.submittedAt': 'Submitted',
  'admin.artradar.rightsOk': 'Image rights confirmed',
  'admin.artradar.rightsNeeded': 'Image permission required',
  'admin.artradar.invites': 'Invitations awaiting connection: {n}',
  'admin.artradar.republished': 'Republished from {name}',
  'admin.artradar.worldRequested': 'World Edition suggested',
  'admin.artradar.action.under_review': 'Start review',
  'admin.artradar.action.request_changes': 'Request changes',
  'admin.artradar.action.approve': 'Approve and publish',
  'admin.artradar.action.decline': 'Decline',
  'admin.artradar.action.revoke': 'Revoke',
  'admin.artradar.notesPrompt': 'Note to the contributor (optional)',
  'admin.artradar.open': 'Open article',
  'admin.artradar.edit': 'Edit',
  'admin.artradar.suspend': 'Suspend submissions',
  'admin.artradar.reinstate': 'Reinstate',
  'admin.artradar.suspendReason': 'Reason for the suspension',
  'admin.artradar.suspended': 'Suspended',
  'admin.artradar.articles': 'Articles: {n}',
  'admin.artradar.noContributors': 'No contributors have registered yet.',
  'legal.impressumArtRadarTitle': 'ArtRadar editorial contributions',
  'legal.impressumArtRadarBody': 'ArtRadar contains editorial contributions from registered ArtRouting users. Submitted articles are reviewed before publication. The named contributor remains responsible for the accuracy of their submitted material and for confirming the required publication and image rights. ArtRouting retains editorial control over acceptance, correction, placement and removal of ArtRadar content.',
  'legal.impressumArtRadarGuidelines': 'ArtRadar Contributor Guidelines',
  'legal.impressumCommercialTitle': 'Commercial content',
  'legal.impressumCommercialBody': 'Paid, sponsored or otherwise commercial content on ArtRouting and ArtRadar is clearly marked as such, and the party behind it is named.',
  // Profile creation, Complete Your Profile, external video links
  'roleBar.switch': 'Role:',
  'profileComplete.title': 'Complete Your Profile',
  'profileComplete.info': 'Profile Information',
  'profileComplete.editInfo': 'Edit profile information',
  'profileComplete.manageRotating': 'Manage rotating gallery',
  'profileComplete.rotatingHelp': 'Add images, studio views, exhibition notices or announcement graphics to the rotating gallery at the top of your profile.',
  'profileComplete.artworkGallery': 'Artwork Gallery',
  'profileComplete.artworkGalleryHelp': 'Your artworks and Artwork PINs appear here automatically. Select an artwork to view its information, location, QR code and connected history.',
  'profileComplete.addArtwork': 'Add an artwork',
  'profileComplete.videos': 'External Video Links',
  'profileComplete.editLinks': 'Edit website and social links',
  'profileComplete.studioPin': 'Studio PIN',
  'profileComplete.studioPinHelp': 'Your Studio PIN sets your exact place on the map and whether it is shown or hidden. Search for an address or place, then confirm or adjust the position on the map.',
  'profileComplete.createStudioPin': 'Create or connect your Studio PIN',
  'profileComplete.connectExisting': 'Connect one of your existing PINs',
  'profileComplete.studioConnected': 'Studio PIN connected.',
  'profileComplete.adjustPin': 'Adjust position',
  'profileComplete.visibility': 'Profile Visibility',
  'profileComplete.visibilityHelp': 'Public profiles appear on ArtRouting. Hidden profiles are kept but not listed. Drafts are not shown to anyone else.',
  'profileVisibility.approved': 'Public',
  'profileVisibility.hidden': 'Hidden',
  'profileVisibility.draft': 'Draft',
  'profileVisibility.pending': 'Under review',
  'profileVisibility.rejected': 'Not approved',
  'profileCreate.title': 'Create Artist Profile',
  'profileCreate.nameRequired': 'Display name is required.',
  'profileCreate.failed': 'The profile could not be created.',
  'profileCreate.haveWebsite': 'Already have a website?',
  'profileCreate.namePlaceholder': 'Your name or artist name',
  'profileCreate.profileImage': 'Profile Image',
  'profileCreate.bioPlaceholder': 'Tell us about yourself and your practice…',
  'profileCreate.medium.painting': 'Painting',
  'profileCreate.medium.sculpture': 'Sculpture',
  'profileCreate.medium.ceramics': 'Ceramics',
  'profileCreate.medium.photography': 'Photography',
  'profileCreate.medium.printmaking': 'Printmaking',
  'profileCreate.medium.mixed_media': 'Mixed Media',
  'profileCreate.medium.digital_art': 'Digital Art',
  'profileCreate.medium.other': 'Other',
  'profileCreate.otherMedium': 'Other medium',
  'profileCreate.otherMediumPlaceholder': 'e.g. Textile, Glass (separate several with commas)',
  'profileCreate.links': 'Website and Social Links',
  'profileCreate.linksHelp': 'Links to your website or social profiles. Links to individual videos are added later under External Video Links.',
  'profileCreate.youtubeChannel': 'YouTube',
  'profileCreate.otherLink': 'Other Professional Link',
  'profileCreate.cityPlaceholder': 'e.g. Berlin',
  'profileCreate.countryPlaceholder': 'e.g. Germany',
  'profileCreate.studioPinNext': 'Your exact map position is set next, with your Studio PIN.',
  'myProfile.draftTip': 'Your profile is a draft and not yet visible to the public. Choose Public under Profile Visibility when you are ready.',
  'imageUpload.label': 'Image',
  'imageUpload.upload': 'Upload',
  'imageUpload.uploadProfile': 'Upload Profile Image',
  'imageUpload.uploading': 'Uploading…',
  'imageUpload.useUrl': 'Use an image URL instead',
  'imageUpload.url': 'Image URL',
  'imageUpload.preview': 'Preview',
  'imageUpload.notImage': 'Please choose an image file.',
  'imageUpload.tooLarge': 'The image must be smaller than 10 MB.',
  'imageUpload.failed': 'Upload failed.',
  'dropZone.drop': 'Drop images here or choose files',
  'dropZone.types': 'JPG, PNG or WebP, up to 10 MB each',
  'dropZone.choose': 'Choose Images',
  'dropZone.takePhoto': 'Take a Photo',
  'dropZone.title': 'Title (also read aloud to visitors using a screen reader)',
  'dropZone.caption': 'Caption (optional)',
  'dropZone.link': 'Link (optional, https://…)',
  'dropZone.rotate': 'Rotate',
  'dropZone.skippedType': 'Some files were left out: only JPG, PNG or WebP images up to 10 MB can be added.',
  'dropZone.overAllowance': 'Only {n} more can be added within your plan allowance.',
  'gallery.openOn.youtube': 'Open on YouTube',
  'gallery.openOn.vimeo': 'Open on Vimeo',
  'gallery.openOn.instagram': 'Open on Instagram',
  'galleryEditor.upgradeFor': 'A higher allowance begins with {tier}.',
  'galleryEditor.seePlans': 'See plans',
  'galleryEditor.topTier': 'This is the highest allowance.',
  'galleryEditor.usage.artworkPins': '{used} of {max} Artwork PINs used',
  'galleryEditor.usage.artworkPinsUnlimited': '{used} Artwork PINs · unlimited',
  'galleryEditor.full.rotating': 'All rotating gallery images are in use. Remove one to add another.',
  'galleryEditor.full.additional': 'All additional gallery images on your plan are in use.',
  'galleryEditor.full.videos': 'All {max} video links on your plan are in use.',
  'galleryEditor.full.artworkPins': 'All {max} Artwork PINs on your plan are in use.',
  'galleryEditor.replaceImage': 'Replace image',
  'galleryEditor.addImages': 'Add {n} images',
  'galleryEditor.videoHelp': 'Add a link to a video published on YouTube, Vimeo or Instagram. ArtRouting does not upload or host video files.',
  'galleryEditor.videoUrl': 'External video URL',
  'galleryEditor.videoDescription': 'Short description (optional)',
  'galleryEditor.dragToReorder': 'Drag images into position on a computer, or use the arrows.',
  'galleryEditor.err.unsupported_video_link': 'Add a link to one video on YouTube, Vimeo or Instagram. A channel or account link belongs under Website and Social Links.',
  'pinForm.positionHelp': 'Type the address or place: the map moves there. Click the map or drag the marker to adjust the exact position.',
  'activity.viewsTitle': 'Opened {total} times in total, {week} in the last 7 days. Your own visits are not counted.',
  'activity.thisWeekShort': 'this week',
  'legal.cookies.updated': 'Last updated: September 2026',
  'legal.cookies.essentialTitle': 'Essential storage only',
  'legal.cookies.essentialBody': 'Signing in keeps a login token in your browser so you stay signed in. It is required for your account to work and is removed when you sign out. If you plan a visit with My Route, its stops are kept in your browser too, and never leave it unless you save the route to your account.',
  'legal.cookies.noTrackingTitle': 'No tracking cookies',
  'legal.cookies.noTrackingBody': 'ArtRouting does not use advertising cookies, third-party analytics or any other tracking cookies.',
  'legal.activityCounts.title': 'Anonymous activity counts',
  'legal.activityCounts.body': 'To show owners how often their public pages are opened, ArtRouting counts page opens, additions to visitor routes, directions opens and video link opens on its own server, without cookies. Only a daily total per page is stored. Repeat opens are recognised for 30 minutes only, using a code derived from your connection and browser that changes every day and cannot identify you. Owners see totals only, never who opened a page. Search engines, link previews and the owners\' own visits are not counted. QR code scans are not part of this count.',
  'myRoute.title': 'My Route',
  'myRoute.chip': 'My Route ({n})',
  'myRoute.addToRoute': 'Add to Route',
  'myRoute.viewRoute': 'View Route',
  'myRoute.backToRoute': 'Back to My Route',
  'myRoute.planThisRoute': 'Plan in My Route',
  'myRoute.empty': 'Your route has no stops yet. Open a place on the map and tap “Add to Route” to collect the stops you want to visit.',
  'myRoute.findStops': 'Find places on the map',
  'myRoute.addMore': 'Add stops',
  'myRoute.clear': 'Clear route',
  'myRoute.clearConfirm': 'Remove every stop from your route?',
  'myRoute.intro': 'Your route is kept in this browser, so it is still here when you open a place, reload or come back from your map app. No account needed.',
  'myRoute.planDay': 'Plan the day',
  'myRoute.start': 'Starting point',
  'myRoute.startPlaceholder': 'Address, town or station',
  'myRoute.useMyLocation': 'Use my location',
  'myRoute.myLocation': 'My location',
  'myRoute.locationUnavailable': 'Your location is not available. Type a starting point instead.',
  'myRoute.date': 'Date',
  'myRoute.startTime': 'Start time',
  'myRoute.hoursAvailable': 'Hours available',
  'myRoute.travelMode': 'Travel mode',
  'myRoute.mode.driving': 'Car',
  'myRoute.mode.walking': 'Walking',
  'myRoute.mode.bicycling': 'Cycling',
  'myRoute.mode.transit': 'Public transport',
  'myRoute.suggestOrder': 'Suggest order',
  'myRoute.suggestOrderHint': 'An approximate order by distance from your start — not the fastest route. You can accept it or keep editing.',
  'myRoute.proposedOrder': 'Suggested order',
  'myRoute.acceptOrder': 'Use this order',
  'myRoute.keepMyOrder': 'Keep my order',
  'myRoute.visited': 'visited',
  'myRoute.skipped': 'skipped',
  'myRoute.unavailable': 'This place is no longer public. It stays in your list until you remove it.',
  'myRoute.noHoursListed': 'No opening hours listed',
  'myRoute.source.owner': 'Hours supplied by the owner',
  'myRoute.source.public': 'Hours as publicly listed',
  'myRoute.source.unknown': 'Source of these hours unknown',
  'myRoute.lastChecked': 'last checked {date}',
  'myRoute.appointmentOnly': 'Visits by appointment — contact them before you go',
  'myRoute.exhibitionNow': 'Exhibition on now',
  'myRoute.warn.noHours': 'No opening hours are listed. Check before you go.',
  'myRoute.warn.unreadableHours': 'These hours could not be checked automatically. Please read them yourself.',
  'myRoute.warn.closedThatDay': 'Listed as closed on the day you chose.',
  'myRoute.warn.notListedThatDay': 'No opening hours are listed for the day you chose.',
  'myRoute.warn.closesBeforeArrival': 'Closes at {time}, before you can arrive even without travel time.',
  'myRoute.warn.mayCloseDuringVisit': 'Closes at {time}; it may close during your visit.',
  'myRoute.warn.opensLater': 'Opens at {time}.',
  'myRoute.warn.exceedsDay': 'The visit times alone are longer than the hours you have. Remove or shorten stops.',
  'myRoute.warn.tightDay': 'Little time is left for travelling between stops. The plan may not fit the day.',
  'myRoute.visitTime': 'Visit time in minutes (suggested {lo}–{hi})',
  'myRoute.legMode': 'Getting here by',
  'myRoute.legModeDefault': 'Day\'s mode ({mode})',
  'myRoute.earliestArrival': 'Earliest arrival {time} (travel time not included)',
  'myRoute.moveUp': 'Move stop up',
  'myRoute.moveDown': 'Move stop down',
  'myRoute.directionsHere': 'Directions',
  'myRoute.markVisited': 'Visited',
  'myRoute.skip': 'Skip',
  'myRoute.backInPlan': 'Back in plan',
  'myRoute.remove': 'Remove',
  'myRoute.summary': 'Your day',
  'myRoute.minutes': '{m} min',
  'myRoute.hoursMinutes': '{h} h {m} min',
  'myRoute.totalVisits': 'Visits: {total} of the {available} you have.',
  'myRoute.travelExcluded': 'Travel time is not included — ArtRouting has no reliable travel-time data. Your map app shows it when you open the directions.',
  'myRoute.startRoute': 'Start the route',
  'myRoute.continueRoute': 'Continue the route',
  'myRoute.nextStop': 'Next stop: {name}.',
  'myRoute.readCard': 'Read its card',
  'myRoute.allDone': 'Every stop is visited or skipped. Enjoy the rest of your day!',
  'myRoute.openAllInMaps': 'Open all stops in Google Maps',
  'myRoute.directionsRemaining': 'Directions for the remaining stops',
  'myRoute.legsReason.too_many': 'Google Maps takes at most five points in one link on a phone, so your route is split into numbered legs.',
  'myRoute.legsReason.transit': 'Public transport directions work one leg at a time, so each leg opens separately.',
  'myRoute.legsReason.mixed_modes': 'Your legs use different travel modes, so each leg opens separately.',
  'myRoute.leg': 'Leg {n}: {from} → {to}',
  'myRoute.whereYouAre': 'where you are',
  'myRoute.keepTitle': 'Keep this route',
  'myRoute.keepLocal': 'It is already kept in this browser. Members can also save it to My Routes to open it on another device.',
  'myRoute.routeName': 'Route name',
  'myRoute.defaultName': 'My route, {date}',
  'myRoute.saveToMyRoutes': 'Save to My Routes',
  'myRoute.updateSaved': 'Update saved route',
  'myRoute.openSaved': 'Open saved route',
  'myRoute.savedToMyRoutes': 'Saved to My Routes. Only you can see it.',
  'myRoute.saveFailed': 'The route could not be saved. Please try again.',
  'myRoute.signInToSave': 'Sign in to save this route to My Routes',
  'myRoute.mapsNote': 'Directions open in Google Maps. ArtRouting does not navigate inside the site.',
  'myRoute.nextOnly': 'Directions to the next stop only',
  'pinForm.hoursSource': 'Where do these opening hours come from?',
  'pinForm.hoursSourceNone': 'Not stated',
  'pinForm.hoursSourceOwner': 'From the owner',
  'pinForm.hoursSourcePublic': 'Publicly listed (e.g. website)',
  'pinForm.hoursSourceUnknown': 'Unknown',
  'pinForm.hoursCheckedAt': 'Hours last checked on',
  'pinForm.hoursHelp': 'Shown to visitors who plan a route, so they know how far to rely on the hours.',
  'heart.follow': 'Follow',
  'heart.following': 'Following',
  'heart.save': 'Save to Interests',
  'heart.saved': 'Saved in Interests',
  'heart.saveArticleAndEvent': 'Save article and its event',
  'heart.savedArticleAndEvent': 'Article and event saved',
  'nav.interests': 'Interests',
  'interests.unreadLabel': '{n} new updates in Interests',
  'interests.title': '♡ Interests',
  'interests.intro': 'Everything you have given a heart to: people and places you follow, and things you saved. New events and articles from them appear here first.',
  'interests.empty': 'Nothing here yet. Tap the heart on an artist, venue, event, artwork or article to keep it here.',
  'interests.explore': 'Explore the map',
  'interests.thisWeek': 'This week',
  'interests.quietWeek': 'Nothing planned this week from what you follow.',
  'interests.newFromFollowed': 'New from what you follow',
  'interests.nextWeek': 'Next week',
  'interests.saved': 'Everything you saved and follow',
  'interests.cat.artists': 'Artists',
  'interests.cat.venues': 'Art venues',
  'interests.cat.profiles': 'Profiles',
  'interests.cat.authors': 'ArtRadar authors',
  'interests.cat.artworks': 'Artworks',
  'interests.cat.events': 'Events',
  'interests.cat.places': 'Places',
  'interests.cat.articles': 'Articles',
  'interests.cat.videos': 'Videos',
  'interests.cat.routes': 'Routes',
  'interests.showAll': 'Show all',
  'interests.untitled': 'Untitled',
  'interests.new': 'New',
  'interests.dateChanged': 'Date changed',
  'interests.cancelled': 'Cancelled',
  'interests.via': 'via {name}',
  'interests.newArticle': 'New article',
  'interests.newArtwork': 'New artwork',
  'interests.addToCalendar': 'Add to calendar',
  'interests.addToMyRoute': 'Add to My Route',
  'interests.emailTitle': 'Weekly email',
  'interests.emailToggle': 'Send me This week by email every Monday',
  'interests.emailHelp': 'Off by default. Every email has a one-click unsubscribe link.',
  'interests.privacy': 'Your hearts are private. Owners only ever see how many hearts an item has, never who gave them.',
  'interests.unsubscribed': 'You will no longer receive the weekly Interests email.',
  'interests.unsubscribeFailed': 'This unsubscribe link is not valid any more.',
  'artworkDetail.askAbout': 'Ask about this artwork',
  'messaging.aboutArtwork': 'About the artwork “{title}”: {url}\n\n',
  'nav.insights': 'Insights',
  'insights.title': 'Insights',
  'insights.intro': 'A private report on how your own records are doing. Only you see it. Each role is compared only with its own earlier period.',
  'insights.roleLabel': 'Role',
  'insights.menuTitle': 'Activity, last 7 days',
  'insights.menuEmpty': 'No records in this role yet.',
  'insights.viewReport': 'View report',
  'insights.m.views7': 'views',
  'insights.m.followers': 'followers',
  'insights.m.saves': 'saves',
  'insights.m.routeAdds7': 'route adds',
  'insights.tab.week': 'Week',
  'insights.tab.month': 'Month',
  'insights.tab.quarter': 'Quarter',
  'insights.tab.year': 'Year',
  'insights.loadFailed': 'The report could not be loaded. Please try again.',
  'insights.periodLine': '{from} to {to}, compared with {pfrom} to {pto}',
  'insights.updated': 'Updated {date}',
  'insights.obsTitle.week': 'This week',
  'insights.obsTitle.month': 'This month',
  'insights.obsTitle.quarter': 'Quarterly trend',
  'insights.obsTitle.year': 'Your year',
  'insights.thisPeriod': 'New this period',
  'insights.rightNow': 'Right now',
  'insights.vsPrevious': 'vs previous period',
  'insights.f.views': 'Views',
  'insights.f.newSaves': 'New saves',
  'insights.f.routeAdds': 'Added to routes',
  'insights.f.directions': 'Directions opened',
  'insights.f.linkOpens': 'Link opens',
  'insights.f.uniqueMembers': 'Members who opened',
  'insights.f.newConnections': 'New connections',
  'insights.f.followersNow': 'Followers right now',
  'insights.f.savesNow': 'Saves right now',
  'insights.f.connectionsNow': 'Connections right now',
  'insights.col.item': 'Item',
  'insights.col.newFollowers': 'New followers',
  'insights.type.artwork': 'Artworks',
  'insights.type.profile': 'Profile',
  'insights.type.pin': 'PINs and places',
  'insights.type.event': 'Events and exhibitions',
  'insights.type.video': 'YouTube videos',
  'insights.type.route': 'Published routes',
  'insights.type.article': 'ArtRadar articles',
  'insights.type.author': 'ArtRadar author',
  'insights.asAuthor': 'You as an ArtRadar author',
  'insights.delegated': 'delegated',
  'insights.noRecords': 'You have no records in this role yet. Once you add a PIN, artwork, event or article, its figures appear here.',
  'insights.lowActivity': 'Low numbers are normal at first. Counting started when this feature launched, visits by you and by search engines are not counted, and repeat visits within 30 minutes count once.',
  'insights.yearChart': 'Views per month over the last 12 months',
  'insights.yearNote': 'Bars show views per month, stacked by role. Use the boxes to show or hide a role.',
  'insights.defsTitle': 'What the numbers mean',
  'insights.defName.views': 'Views',
  'insights.defName.saves': 'Saves',
  'insights.defName.followers': 'Followers',
  'insights.defName.routeAdds': 'Added to routes',
  'insights.defName.directions': 'Directions opened',
  'insights.defName.linkOpens': 'Link opens',
  'insights.defName.uniqueMembers': 'Members who opened',
  'insights.defName.connections': 'Connections',
  'insights.def.views': 'How often the item\'s page was opened. Your own visits, bots and repeats within 30 minutes are not counted.',
  'insights.def.saves': 'How many members gave the item a heart. You see the number, never who.',
  'insights.def.followers': 'Hearts on your profile and on you as an ArtRadar author. You see the number, never who.',
  'insights.def.routeAdds': 'How often a visitor added the place as a stop to their own route plan. Whose route is never shown.',
  'insights.def.directions': 'How often someone opened directions to the place in Google Maps.',
  'insights.def.linkOpens': 'How often a YouTube link was opened. ArtRouting cannot see whether the video was watched, so these are never called views.',
  'insights.def.uniqueMembers': 'Distinct signed-in members who opened the video link in this period.',
  'insights.def.connections': 'People you have a two-way conversation with in ArtRouting Messages. Names and messages are never part of Insights.',
  'insights.privacy': 'Insights never shows who visited, who saved, private routes, messages, provenance, documents, price requests or any QR figures.',
  'insights.obs.noRecords': 'There is nothing to report yet because this role has no records.',
  'insights.obs.quiet': 'No views were counted in this period or the one before.',
  'insights.obs.actShare': 'Suggestion: share the link to your PIN or profile with your contacts, it is the quickest way to your first visitors.',
  'insights.obs.week.first': '{views} views this week, the first counted.',
  'insights.obs.week.up': '{views} views this week, up {pct}% on last week.',
  'insights.obs.week.down': '{views} views this week, down {pct}% on last week.',
  'insights.obs.week.same': '{views} views this week, the same as last week.',
  'insights.obs.month.first': '{views} views in the last 30 days, the first counted.',
  'insights.obs.month.up': '{views} views in the last 30 days, up {pct}% on the 30 days before.',
  'insights.obs.month.down': '{views} views in the last 30 days, down {pct}% on the 30 days before.',
  'insights.obs.month.same': '{views} views in the last 30 days, the same as the 30 days before.',
  'insights.obs.quarter.first': '{views} views this quarter, the first counted.',
  'insights.obs.quarter.up': 'The trend is rising: {views} views this quarter, up {pct}% on the quarter before.',
  'insights.obs.quarter.down': 'The trend is falling: {views} views this quarter, down {pct}% on the quarter before.',
  'insights.obs.quarter.same': 'The trend is steady: {views} views this quarter, as in the quarter before.',
  'insights.obs.top': 'Most viewed: {name} ({views}).',
  'insights.obs.actImprove': 'Suggestion: {name} is being looked at but not saved yet. A better photo or a fuller description can help.',
  'insights.obs.actHours': 'Suggestion: your places are viewed but not yet added to routes. Opening hours with a last-checked date make planning a visit easier.',
  'insights.obs.actEvent': 'Suggestion: add an upcoming event or exhibition, followers see new events first in their Interests.',
  'insights.obs.actKeep': 'Suggestion: keep your dates and images current, that is what brings people back.',
  'insights.obs.year.best': 'Your best month was {month} with {views} views.',
  'insights.obs.year.up': 'The last six months were {pct}% busier than the six before.',
  'insights.obs.year.down': 'The last six months were {pct}% quieter than the six before.',
  'insights.obs.year.started': '{views} views since counting began.',
  'activity.routeAddsTitle': 'Added to visitor routes {total} times, {week} in the last 7 days',
  'qa.title': 'Questions & answers',
  'qa.navLabel': 'Questions & answers',
  'qa.cardLink': 'Questions & answers',
  'qa.intro': 'Short answers about ArtRouting, by topic. Every question has its own link you can share.',
  'qa.contents': 'Topics',
  'qa.linkToQuestion': 'Link to this question',
  'qa.moreQuestions': 'Another question?',
};

export default en;
